class DocumentationScreenController {

    constructor() {

        // Opciones de cada documento que al activarlas llevan a la vista detalles
        this.COMMENT_OPTION = 'comment';
        this.SHARE_OPTION = 'share';
        this.RATE_OPTION = 'rate';
        this.SEE_ALL_COMMENTS_OPTION = 'seeAllComments';

        var that = this;
        this.documentationPageSize = 20;
        this.setDocumentationInterval = null;
        this.documentation = null; // Árbol con toda la documentación que se ha ido consultando
        this.documentsAsResources = {}; // Diccionario con los documentos a los que apuntan los elementos decorativos y enlaces internos
        this.foldersStack = [];
        this.template = Handlebars.compile($("#worldDocumentationScreen").html());
        this.advancedTemplate = Handlebars.compile($("#worldDocumentationAdvancedScreen").html());
        this.singleMenuTemplate = Handlebars.compile($("#fullModalMenu").html());
        this.documentDetailsTemplate = Handlebars.compile($("#worldDocumentationDetailScreen").html());
        this.countdownTemplate = Handlebars.compile($("#countdownScreen").html());
        this.userCompletenessIndicatorTemplate = Handlebars.compile($("#userCompletenessIndicator").html());
        this.documentActivityTab = Handlebars.compile($("#documentActivityTab").html());
        this.documentCommentsTab = Handlebars.compile($("#documentCommentsTab").html());
        this.clipboardItem = null;
        this.pageDocument = $(document);
        this.elapsedSendingTime = null;
        this.currentDocumentDetails = null;
        this.tabs = new Tabs();
        this.documentationStandarViewPaginator = new DocumentationStandarViewPaginator();
        this.documentationAdvancedViewPaginator = new DocumentationAdvancedViewPaginator();
        this.documentationNew = new DocumentationNew();
        this.documentationPublish = new DocumentationPublish();
        this.documentationShareChat = new DocumentationShareChat();
        this.documentationSockets = new DocumentationSockets();
        this.documentationScroll = new DocumentationScroll();
        this.sharedLinkController = new SharedLinkScreenController();
        this.documentationProgress = new DocumentationProgress();
        this.documentationGoUp = new DocumentationGoUp();
        this.documentationFilters = new DocumentationFilters();
        this.documentationPath = new DocumentationPath();
        this.documentationComment = new DocumentationComment();
        this.slideActionsFriendList = new SlideActionsFriendList();
        this.slideActionsDocumentList = new SlideActionsDocumentList();
        this.screen = null;
        this.isDragging = false;
        this.folderModeView = null;
        this.documentsRoutes = {};
        this.documentsViews = {};
        this.countDownGame = null;
        this.documentationTags = null;
        this.documentationDifficultyTimes = [];
        this.documentationDifficultyPoints = [];
        this.reDrawFolder = false // Este flag servira para saber si al cerrar el path se ha de volver a dibujar la carpeta o no (evitar ids duplicadas en la vista muro y path muro)
        this.scrollPosition = 0;
        this.loadPartialsTemplates();

        //set events for Tasks
        this.setTaskViewEvents();

        // Detener progreso del documento si esta activo al salir de la documentacion.
        $(document).on('click', '.selected-tab, #playerImg, #baseWorldIconLink', function(e) {
            if (that.documentationScroll.currentReadingDocument) {

                const documentId = that.documentationScroll.currentReadingDocument;
                const selectorTarget = $(this)[0].id;
                const document = that.getDocument(documentId);

                that.documentationProgress.stopRead(document.id);

                if (['AUDIO', 'VIDEO'].indexOf(document.type) >= 0) {
                    pauseMedia($('.documentation-advanced-documents-row[data-document=' + documentId + ']').find(document.type)[0]);
                }
            }
        })

        $(document).on('click', '#documentation-header-close-btn, #documentation-header-back-btn, .bf-close-button', function (e) {
            //Path closing
            const pathData = documentationScreenController.documentationPath?.getPathData() ?? null;

            if (pathData &&
                pathData?.progressState?.state === 'COMPLETED' &&
                pathData?.document_root?.completed_points &&
                !pathData?.document_root?.read
            ) {
                DocumentationUtils.showPointsModal(pathData.document_root.completed_points, 0);
            }

            // Colocar el color de fondo por defecto
            $('.quiz-wrapper').attr('class', 'quiz-wrapper');

            const advancedView = storage.getItem("documentation-advanced-mode") === 'true';
            const documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;

            if(!baseController.selectedTabId) {
                baseController.selectedTabId = baseController.getTabByWorldTab($('.nav-tabs .active a')) ? baseController.getTabByWorldTab($('.nav-tabs .active a').attr('id')).id : null;
                if(baseController.selectedTabId === that.tabs.CHAT_TAB) {
                    chatScreenController.drawChatList(chatScreenController.rooms);
                    return false;
                }
            }

            // Quitar el fragmento que se añade cuando clicas para ver el perfil de un usuario
            if (friendsScreenController.hasToRemoveChatProfileStack) {
                baseController.closeStack();
                friendsScreenController.hasToRemoveChatProfileStack = false;
            }

            if (that.currentDocumentDetails) {

                const document = that.currentDocumentDetails;

                if (!document.isPathTestContent) {
                    that.documentationProgress.stopRead(document.id);
                }

                if (['AUDIO', 'VIDEO'].indexOf(document.type) >= 0) {
                    if (!document.external) {
                        pauseMedia($('#documentationDetailSection').find(document.type)[0]);
                    }
                }

                that.currentDocumentDetails = null;

            }

            if(that.clipboardItem !== null){
                that.clipboardItem.destroy();
                that.clipboardItem = null;
            }
            $('#welcome-choose-avatar-container').hide();
            that.closeDocumentDetails(that.documentationPath.getReturnToPath(), that.documentationPath.getReturnToPathWizardPreview());
            $('.nav-tabs').scrollingTabs('refresh');

            // No cambiar de vista si se esta en detalles y se abre el perfil u otra pestaña que no este en la navbar
            if ($('#documentationDetailSection').is(':visible')) {
                that.folderModeView = 'details';
            } else {
                // Mostrar el boton del finder al salir de la vistad detalles
                $('#open-finder-button').show();

                if (!documentOpenedInChat) {

                    that.folderModeView = advancedView ? 'advanced' : 'standar';
                    const folder = that.getCurrentFolder();
                    // Solo lanzar el gestor de los contenedores cuando exista la carpeta, si no existe es porque se ha abierto el contenido desde fuera de la documentacion
                    if (folder) {
                        that.manageDocumentContainers(folder);
                    }

                }

            }

            if (that.countDownGame) {
                that.countDownGame.stop();
                that.countDownGame = null;
            }

            // Al cerrar la vista restablecer el scroll a la ultima posicion que tenia antes de acceder a la vista detalles.

            if(that.scrollPosition) {
                window.scrollTo(0, that.scrollPosition);
            }
            that.documentationScroll.lastScrollPosition = 0;
            chatScreenController.projectDocumentDetailsOpen = false;
            finderController.documentOpen = false;
            finderController.documentMatch = null;

            const nav = document.querySelector('.body__container__content nav.dropdown');

            if (nav) {
                const header = document.querySelector('#ranking-details-header');

                if (!header) {
                    setTimeout(() => {
                        document.querySelectorAll('.body__container__content nav.dropdown').forEach((nav) => {
                            nav.remove();
                        });
                    }, 100);
                }
            }
        });

        $(document).on('click', '.documentation-folder-header-back-btn', function (e) {

            const documentationContent = $('.documentation-content');
            let advancedView = storage.getItem("documentation-advanced-mode") === 'true';
            let lastReadingItem = that.documentationScroll.currentReadingDocument;
            let oldFolder = that.getCurrentFolder();
            let lastDocument = null;

            if(lastReadingItem && oldFolder['documents'])
                lastDocument = oldFolder['documents'][that.getDocumentIndex(lastReadingItem)];
            if(advancedView && lastDocument && DocumentationUtils.isAutomaticReadingDocument(lastDocument.type)){
                that.documentationSockets.callbackReadingFunc = function () {
                    let currentFolder = that.getCurrentFolder();
                    if(currentFolder.name !== Translator.trans('TR_RESULTS'))
                        $(that.screen).find('.documentation-searcher input').val('');

                    if(currentFolder.documents){
                        let firstListItem = $(that.screen).find(".documentation-advanced-documents-row[data-folder='" + currentFolder.id +"']").first();
                        that.documentationScroll.markAsReadingItem(firstListItem);
                    }
                };

                that.documentationProgress.stopRead(lastDocument.id)

                that.updateScreensStack();
            } else {
                that.updateScreensStack();

                // Si se ha llegado mediante un enlace: hay que volver a la carpeta que contiene el enlace (internal-link-folder), no a la padre.
                let currentFolderId = $(this).attr("internal-link-folder");
                let currentFolder;

                if(currentFolderId) {
                    currentFolder = that.getFolder(that.documentation, currentFolderId)
                } else {
                    currentFolder = that.getCurrentFolder();
                }

                if(currentFolder.name !== Translator.trans('TR_RESULTS'))
                    $(that.screen).find('.documentation-searcher input').val('');

                if(advancedView && currentFolder.documents){
                    let firstListItem = $(that.screen).find(".documentation-advanced-documents-row[data-folder='" + currentFolder.id +"']").first();
                    that.documentationScroll.markAsReadingItem(firstListItem);
                }

            }

            // Al retroceder entre carpetas / resultados de filtros debe vaciarse la variable que guarda el id del documento que se estaba leyendo
            if ($(".documentationSectionStackable").last().find("#documentation-folders-table").length > 0) {
                that.documentationScroll.currentReadingDocument = null;
            }

            const currentFolder = that.getCurrentFolder();
            const isRootFolder = that.documentation.id === currentFolder.id || currentFolder.id === '';
            const difficultyTimesFormatted = that.documentationDifficultyTimes;
            const difficultyPointsFormatted = that.documentationDifficultyPoints;
            const documentationTags = that.documentationTags;

            if (currentFolder.folders || documentationScreenController.folderModeView === 'standar') {
                documentationScreenController.documentationStandarViewPaginator.initialize(currentFolder, difficultyTimesFormatted, difficultyPointsFormatted, documentationTags);
            } else if (documentationScreenController.folderModeView === 'advanced') {
                documentationScreenController.documentationAdvancedViewPaginator.initialize(currentFolder, difficultyTimesFormatted, difficultyPointsFormatted, documentationTags);
            }

        });

        $(document).on('click', '.documentation-folders-link', function (e) {
            var link = $(e.target).closest('.documentation-folders-link');
            var folderIndex = link.attr('data-folder-index');

            that.folderIndex = folderIndex;

            if (that.foldersStack.length > 0) {
                var currentFolder = that.foldersStack.pop();
                that.foldersStack.push(currentFolder);
                var targetFolder = currentFolder.folders[folderIndex];

                api.getFolderDocuments(targetFolder.id, 0, that.documentationPageSize, function(response) {
                    currentFolder.folders[folderIndex] = response.result;
                    that.drawFolder(response.result);
                });

            }
        });

        $(document).on('keypress', '.documentation-searcher input', function (e) {
            if (e.keyCode === 13) { // Enter key
                let lastReadingItem = that.documentationScroll.currentReadingDocument;
                let isMultimedia = lastReadingItem ? DocumentationUtils.isMultimediaDocument(lastReadingItem.type) : false;
                let isAdvanced = lastReadingItem ? DocumentationUtils.isAdvancedDocument(lastReadingItem.type) : false;

                let term = $(this).val();
                that.search(term);
            }
        });

        $(document).on('click', '.folder-info-btn', function (e) {

            e.preventDefault();
            e.stopPropagation();

            let btn = $(e.target).closest('.folder-info-btn');
            let folderIndex = btn.data('folder-index');

            if (that.foldersStack.length > 0) {
                let currentFolder = that.getCurrentFolder();
                let targetFolder = currentFolder.folders[folderIndex];
                that.showFolderInfo(targetFolder);
            }

            return false;

        });

        $(document).on('click', '#documentation-open-folder-info-btn', function (e) {
            let currentFolder = that.getCurrentFolder();
            that.showFolderInfo(currentFolder);

        });

        $(document).on('click', '.documents-filter', function (e) {

            let currentFolder = $.extend(true,{},that.getCurrentFolder());
            let startFolderId = currentFolder.id;
            let oldFiltersList = $(that.screen).find('.filterEnabled');
            let oldFiltersAmount = oldFiltersList.length;
            let searchTerm = $(that.screen).find('.documentation-searchbar').val();
            let activeFilters = that.toggleCurrentFilter(oldFiltersList, $(this));
            let activeFiltersDict = _.mapValues(_.keyBy(activeFilters, 'filterType'), 'status');
            let filterFolder = that.getCurrentFolder();
            let advancedView = storage.getItem("documentation-advanced-mode") === 'true';
            let lastReadingItem = that.documentationScroll.currentReadingDocument;
            let resultDocuments = [];
            const filters = {
                is_completed_by_user: activeFiltersDict["completed"] === "1",
                is_fav_to_user: activeFiltersDict["favourite"] === "1",
                is_new_to_user: activeFiltersDict["new"] === "1",
                has_test: activeFiltersDict["test"] === "1",
                has_question: activeFiltersDict["play"] === "1",
                order_by_rating: activeFiltersDict["rating"] === "1",
                is_shared_by_user: activeFiltersDict["share"] === "1",
            };

            _.forEachRight(documentationScreenController.foldersStack, function(folder) {
                if (!folder.isResult && String(folder.id).indexOf("-") < 0) {
                    startFolderId = folder.id;
                    return false;
                }
            });

            if(activeFilters.length !== 0){

                function applyFilter(){

                    let resultFolder = {
                        id: new Date().getTime(),
                        name: Translator.trans('TR_RESULTS'),
                        color: '#' + that.getCurrentFolder().color,
                        documents: resultDocuments,
                        isResult: true
                    };

                    that.drawFolder(resultFolder, false, false, true, function() {
                        DocumentationUtils.drawFilters(activeFilters,  resultFolder);
                    });

                }

                currentFolder.id = currentFolder.id + "-" + Date.now();

                api.searchDocumentsInFolder(startFolderId, searchTerm, filters, function(response) {

                    resultDocuments = response.result ? Object.values(response.result) : [];

                    if(advancedView && lastReadingItem) {
                        let prevFolder = that.getCurrentFolder();

                        that.documentationSockets.callbackReadingFunc = function () {
                            if(that.getCurrentFolder().folders && searchTerm.length){
                                that.drawFolder(prevFolder, false, false);
                            }

                            applyFilter();

                            $(that.screen).find('.documentation-searchbar').val(searchTerm);
                        };

                        if (oldFiltersAmount !== 0) {
                            that.updateScreensStack();
                        } else {
                            that.documentationScroll.stopCurrentReadingItem(null, $(that.screen).find('.documentation-advanced-documents-row[data-folder="' + filterFolder.id + '"]').first());
                        }
                    } else {
                        if(oldFiltersAmount !== 0)
                            that.updateScreensStack();

                        applyFilter();

                    }
                });
            } else {
                if(lastReadingItem && advancedView){
                    that.documentationSockets.callbackReadingFunc = function (){
                        if(searchTerm.length){
                            that.search(searchTerm);
                        } else {
                            let firstListItem = $(that.screen).find(".documentation-advanced-documents-row[data-folder='" + that.getCurrentFolder().id +"']").first();
                            that.documentationScroll.markAsReadingItem(firstListItem);
                        }
                    };
                    that.updateScreensStack();
                } else {
                    that.updateScreensStack();

                    if(searchTerm.length){
                        that.search(searchTerm);
                    } else if(advancedView && that.getCurrentFolder().documents) {
                        let firstListItem = $(that.screen).find(".documentation-advanced-documents-row[data-folder='" + that.getCurrentFolder().id + "']").first();
                        that.documentationScroll.markAsReadingItem(firstListItem);
                    }
                }
            }

            $(that.screen).find('.documentation-searchbar').val(searchTerm);
        });

        $(document).on('click.docTypeGameButton', '.bf-smart-list.game-controller .action-button', function() {

            const documentId = $(this).attr('data-id');
            const folder = that.getCurrentFolder();
            let document = $.grep(folder.documents, function(e){ return e.id == documentId; })[0];

            if (!document) {
                document = that.getDocument(documentId);
            }

            that.drawDocumentDetails(null, document, null, folder);

        });

        //action button "start test"
        $(document).on(
            'click.docTypeTestButton',
            '.bf-smart-list.test-controller .action-button',
            _.debounce(function() {
            const documentId = $(this).attr('data-id');
            const folder = that.getCurrentFolder();
            let document = $.grep(folder.documents, function(e){ return e.id == documentId; })[0];

            if (!document) {
                document = that.getDocument(documentId);
            }

            that.drawDocumentDetails(null, document);
        }, 500));

        //action button poll
        $(document).on(
            'click.docTypePollButton',
            '.bf-smart-list.poll-controller .action-button',
            _.debounce(function() {
            const documentId = $(this).attr('data-id');
            const folder = that.getCurrentFolder();
            let document = $.grep(folder.documents, function(e){ return e.id == documentId; })[0];

            if (!document) {
                document = that.getDocument(documentId);
            }

            documentObj = new DocumentObj(document, that.foldersStack);

            if (document.own_poll.games.length === 0) {
                api.createNewDocumentGame(documentId);

                return;
            }

            that.drawDocumentDetails(null, document);
        }, 500));

        $(document).on('click', '#startDocGameBtn', function (e) {

            let documentId = $(this).attr('data-id');
            let folder = that.getCurrentFolder();
            let documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;

            if (documentOpenedInChat) {
                documentId = $('.open-project-document-details').data('document');
                folder = that.getParentFolder(documentId, that.documentation);
            }

            // Mirar si se encuentra en la misma carpeta
            let document = $.grep(folder.documents, function(e){ return e.id == documentId; })[0];

            if (!document) {
                // Es un enlace a un documento. Mirar donde está el documento al que referencia desde ROOT.
                document = that.getDocument(documentId);
            }

            documentObj = new DocumentObj(document,that.foldersStack);

            that.documentationProgress.stopRead(document.id);

            if (['AUDIO', 'VIDEO'].indexOf(document.type) >= 0) {
                if (that.folderModeView === 'details') {
                    pauseMedia($('#documentationDetailSection').find(document.type)[0]);
                } else {
                    pauseMedia($('.documentation-advanced-documents-row[data-document=' + documentId + ']').find(document.type)[0]);
                }
            }

            if (finderController.documentOpen) {
                finderController.documentOpen = false;
            }

            api.createNewDocumentationTest(world.token, documentId);
        });

        $(document).on('click', '#startTestBtn, .startTestBtn', function (e) {

            let documentId = $(this).attr('data-id');
            let folder = that.getCurrentFolder();
            let documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;

            if (documentOpenedInChat) {
                documentId = $('.open-project-document-details').data('document');
                folder = that.getParentFolder(documentId, that.documentation);
            }

            let document = $.grep(folder.documents, function(e){ return e.id == documentId; })[0];
            let template = Handlebars.compile($("#testStartModal").html());
            let context = {
                document: document,
                world: world,
                test_points: document.test_points.toLocaleString("es-ES")
            };

            documentObj = new DocumentObj(document,that.foldersStack);

            that.documentationProgress.stopRead(document.id);

            if (['AUDIO', 'VIDEO'].indexOf(document.type) >= 0) {
                if (that.folderModeView === 'details') {
                    pauseMedia($('#documentationDetailSection').find(document.type)[0]);
                } else {
                    pauseMedia($('.documentation-advanced-documents-row[data-document=' + documentId + ']').find(document.type)[0]);
                }
            }

            $("#modalContainer").html(template(context)).modal('show');
            $('#resumen-partido').attr('data-dimension', $(window).width() <= 420 ? '138' : '188');
            $('#resumen-partido').circliful({
                adjustToContainer: true
            });

            $('.start-test-modal-close').click(function (e) {
                $("#modalContainer").modal('hide').empty();
            });
        });

        $(document).on('click', '#documentStartGameBtn', function (e) {
            let documentId = $(this).attr('data-id') ;
            if (finderController.documentOpen) {
                finderController.documentOpen = false;
            }
            api.createNewDocumentationTest(world.token, documentId);
        });

        $(document).on('click', '.modal-close-btn', function (e) {
            $("#modalContainer").modal('hide').empty();
        });
    }

    loadPartialsTemplates() {
        Handlebars.registerPartial("floatButtonsFragment", $("#floatButtonsFragment").html());
        Handlebars.registerPartial("filtersFragment", $("#filtersFragment").html());
        Handlebars.registerPartial("availableFiltersFragment", $("#availableFiltersFragment").html());
        Handlebars.registerPartial("documentMatchesFragment", $("#documentMatchesFragment").html());
        Handlebars.registerPartial("documentPastilFragment", $("#documentPastilFragment").html());
        Handlebars.registerPartial("documentIndicatorsFragment", $("#documentIndicatorsFragment").html());
        Handlebars.registerPartial("documentGameDetailsCover", $("#documentGameDetailsCover").html());
        Handlebars.registerPartial("documentGameDetails", $("#documentGameDetails").html());
        Handlebars.registerPartial("documentInformationTab", $("#documentInformationTab").html());
        Handlebars.registerPartial("activityCard", $("#activityCard").html());
        Handlebars.registerPartial("documentComment", $("#documentComment").html());
        Handlebars.registerPartial("documentDetailsDrawer", $("#documentDetailsDrawer").html());
    }

    setDocumentation(documentation) {
        this.documentation = documentation;
    }

    getScreen() {
        // console.trace('this.foldersStack.length:  ', this.foldersStack.length);
        this.screen =  $(".documentationSectionStackable[data-stack='" + this.foldersStack.length + "']");
        // this.screen = $("#legacyStack");
        return this.screen;
    }

    findNode(id, currentNode, startReadingScroll = true) {
        if (id == currentNode.id) {
            // El startFolder de cada usuario se correspondera a la primera posicion del stack de pantallas segun permisos, no tiene porque ser ROOT.
            this.drawFolder(currentNode, id === documentObj.folder_stack[0]?.id, startReadingScroll);
        } else {
            for(var index in currentNode.folders){
                var node = currentNode.folders[index];
                this.findNode(id, node,  startReadingScroll);
            }
        }

    }

    openDocumentation(documentation, folderId, tabId, isFullModal = false) {
        function _openDocumentation() {

            that.foldersStack = [];
            that.documentation = documentation;
            that.documentationSockets.startNodeConnection();

            if (isFullModal) {
                baseController.resetStackableOrder();
                baseController.stackSimpleMenu({title: 'TR_DOCUMENTACION'}, that.singleMenuTemplate);
            } else {
                baseController.resetStackableOrder();
                $(that.screen).find("#jugar").html("");
                baseController.drawMainMenu(tabs.LINKS_TAB, tabId);
            }

            // Vaciar el stack de pantallas al clicar en otra pestaña de documentación
            $('.documentationSectionStackable').each(function (e) {
                $(this).remove();
            });

            let folder = that.documentation;

            if ((typeof  documentObj != 'undefined') && documentObj){
                documentObj.folder_stack.forEach(function(element) {
                    if (element?.id) {
                        that.findNode(element.id,folder, false);
                    }
                });

                let currentDocRow = null;
                const ownGameSpecialView = documentObj.own_game && documentObj.own_game.special_view;
                const ownTestSpecialView = documentObj.own_test && documentObj.own_test.special_view;
                const ownPollSpecialView = documentObj.own_poll && documentObj.own_poll.special_view;

                if (ownGameSpecialView || ownTestSpecialView || ownPollSpecialView) {
                    currentDocRow = $(that.screen).find(".documentation-documents-special-row[data-document='" + documentObj.id +"']");
                } else {
                    currentDocRow = $(that.screen).find(".documentation-advanced-documents-row[data-document='" + documentObj.id +"']");
                }

                let advancedView = storage.getItem("documentation-advanced-mode") === 'true';

                if(advancedView && currentDocRow.length > 0) {
                    that.documentationScroll.autoPlayDoc = false;

                    $(that.screen).find('.documentation-content').last().animate({"scrollTop": currentDocRow.position().top + 1}, function () {
                        documentationScreenController.documentationScroll.markAsReadingItem(currentDocRow);
                        documentationScreenController.documentationScroll.updateLastRead(currentDocRow);
                        that.documentationScroll.autoPlayDoc = true;
                        documentObj = null;
                    });
                } else {
                    documentObj = null;
                }
            } else{
                // Obtener el arbol de documentos y carpetas a dibujar
                if(folderId)
                    folder = that.getFolder(folder, folderId);

                that.drawFolder(folder, true, root);
            }

        }

        var that = this;
        let tabs = new Tabs();
        let root = this.documentation.id == folderId || folderId == '' || !this.documentation.parent_id;

        _openDocumentation();
    }

    getFolder(folder, folderId) {
        let that = this;
        let result = null;

        if (folder && folder.id == folderId)
            return folder;  // Es el folder actual

        if (folder && folder.folders) {
            let folders = folder.folders;
            Object.keys(folders).forEach(function (key) {
                if (result === null)
                    result = that.getFolder(folders[key], folderId);
            });
            return result;
        }

        return null;    // No se ha encontrado el resultado
    }


    getFolderIndexes(folder, folderId) {

        let indexes = getIndexes(folder, folderId);
        indexes.reverse();
        indexes.pop();
        return indexes;

        function getIndexes(folder, folderId, index = null) {
            let result = [];

            if (folder && folder.id == folderId) {
                result.push(index);  // Es el folder actual
                return result
            }

            if (folder && folder.folders) {
                let folders = folder.folders;
                Object.keys(folders).forEach(function (key) {
                    if (result === null || result.length === 0) {
                        result = getIndexes(folders[key], folderId, key);
                        if (result) {
                            result.push(key)
                        }
                    }
                });
                return result;
            }
            return null;
        }
    }

    getDocument(documentId, folder = null) {

        const that = this;

        function _findInCurrentFolder() {
            const currentFolder = that.getCurrentFolder();

            if (currentFolder && currentFolder.documents) {

                const documents = currentFolder.documents;

                return _.find(documents, function(doc) {
                    return doc.id === parseInt(documentId);
                });

            }

            return null;

        }

        function _findDocumentInTree(currentFolder) {
            let result = null;

            if (!currentFolder) {
                currentFolder = that.documentation;
            }

            if (currentFolder && currentFolder.id === documentId) {
                return currentFolder;
            }

            // Recorrer todas las carpetas
            if (currentFolder && currentFolder.folders) {

                let folders = currentFolder.folders;

                Object.keys(folders).forEach(function (key) {
                    if (result === null) {
                        result = _findDocumentInTree(folders[key]);
                    }
                });

                return result;
            }

            // Si hay documentos, comprobar si esta el documento
            if (currentFolder && currentFolder.documents) {

                let documents = currentFolder.documents;

                Object.keys(documents).forEach(function (key) {
                    let doc = documents[key];
                    if(doc.id == documentId) {
                        result = doc
                    }
                });

                return result;
            }

            return null;

        }

        let document = null;

        // 1º Busca si ya lo tienes porque es un documento referenciado por un enlace interno o documento decorativo
        document = that.documentsAsResources[documentId];

        // 2º Si no lo ha encontrado busca el documento en la carpeta actual
        document = document || _findInCurrentFolder();

        // 3º Si no lo ha encontrado busca el documento en el árbol local de carpetas y documentos a partir de la carpeta especificada...
        document = document || _findDocumentInTree(folder);

        // 4º Si no esta pidelo a backend
        if (!document && documentId) {

            api.getDocumentInfo(documentId, function(response) { 
                if (response.success) {
                    document = response.result;
                    // Guardar el documento para no buscarlo nuevamente
                    that.documentsAsResources[documentId] = document;
                }
            }, true, true); // showModal = true, skipCheckResult = true

        }

        if (!Object.isExtensible(document)) {
            return JSON.parse(JSON.stringify(document));
        }

        return document;
    }

    // Obtener los documentos de un folder por los que se puede filtrar
    /**
     * @param {Object} folder
     * @param {Array} visited
     * @returns {Array}
     */
    getFolderDocumentsFilter(folder, visited = []) {
        let that = this;
        let docs = [];

        if(folder.documents) {
            folder.documents.forEach(function (doc) {
                let isAdvanced = ['BANNER','BANNERX2','DECO_GALLERY', 'TITLE'].indexOf(doc.type) >= 0;

                if (doc.type === 'TITLE' && doc.sub_type === 'FOLDER') {
                    let folder = that.getFolder(that.documentation, doc.resource);
                    if(folder && visited.indexOf(folder.id) < 0) {
                        visited.push(folder.id);
                        let subfolderResultDocuments = that.getFolderDocumentsFilter(folder, visited);
                        docs = docs.concat(subfolderResultDocuments);
                    }
                }

                if (['BANNER','BANNERX2','DECO_GALLERY', 'GALLERY'].indexOf(doc.type) >= 0) {
                    // Recorrer todas las imagenes y si alguna apunta a una carpeta, buscar dentro de la carpeta
                    doc.images.forEach(function (image) {
                        if (image.sub_type === 'FOLDER') {
                            let folder = that.getFolder(that.documentation, image.resource);
                            if(folder && visited.indexOf(folder.id) < 0) {
                                visited.push(folder.id);
                                let subfolderResultDocuments = that.getFolderDocumentsFilter(folder, visited);
                                docs = docs.concat(subfolderResultDocuments);
                            }
                        }
                    });
                }

                if (doc.type === "INTERNAL_LINK") {
                    doc = that.getDocument(doc.resource);
                }

                if(!isAdvanced && doc) {
                    docs.push(doc);
                }
            });
        }

        if (folder.folders) {
            folder.folders.forEach(function (folder) {
                if(visited.indexOf(folder.id) < 0) {
                    visited.push(folder.id);
                    let subfolderResultDocuments = that.getFolderDocumentsFilter(folder, visited);
                    docs = docs.concat(subfolderResultDocuments);
                }
            });
        }

        return docs;
    }

    // Obtener los documentos de un folder
    getFolderDocuments(folder) {
        let that = this;
        let docs = [];

        if(folder.documents) {
            Object.keys(folder.documents).forEach(function (key) {
                let doc = folder.documents[key];

                if (doc.type === "INTERNAL_LINK") {
                    // Si el usuario no tiene acceso al documento, mostrar el enlace y al clicarlo un mensaje de que no se tienen permisos
                    let docLinked = that.getDocument(doc.resource);
                    if(docLinked) {
                        let isCompactView = doc.is_compact_view;
                        let resource = doc.resource;
                        doc = $.extend({}, docLinked);
                        doc.is_compact_view = isCompactView;
                        doc.resource = resource;
                        // Guardar el documento al que apunta para no buscarlo nuevamente
                        that.documentsAsResources[doc.resource] = docLinked;
                    }
                    DocumentationUtils.formatDocumentParameters(doc, folder);
                } else if (doc.type === "DECO_GALLERY" || doc.type === "GALLERY") {
                    _.forEach(doc.images, function (image) {
                        if(image.sub_type == "DOCUMENT") {
                            let docLinked = that.getDocument(image.resource);
                            if (docLinked) {
                                image.url = docLinked.url;
                                image.sub_type = docLinked.sub_type ? docLinked.sub_type : image.sub_type;
                                // Guardar el documento al que apunta para no buscarlo nuevamente
                                that.documentsAsResources[image.resource] = docLinked;
                            }
                        }
                    });
                } else {
                    // En caso de ser un elemento decorador, mirar si enlaza con un documento y en ese caso añadirle la url del documento
                    if (doc.type === "BANNER" || doc.type === "BANNERX2") {
                        _.forEach(doc.images, function (image) {
                            if(image.sub_type == "DOCUMENT") {
                                let docLinked = that.getDocument(image.resource);
                                if (docLinked) {
                                    image.url = docLinked.url;
                                    // Guardar el documento al que apunta para no buscarlo nuevamente
                                    that.documentsAsResources[image.resource] = docLinked;
                                }
                            }
                        });
                    } else {
                        if(doc.type === "TITLE" && doc.sub_type == "DOCUMENT") {
                            let docLinked = that.getDocument(doc.resource);
                            if (docLinked) {
                                doc.url = docLinked.url;
                                // Guardar el documento al que apunta para no buscarlo nuevamente
                                that.documentsAsResources[doc.resource] = docLinked;
                            }
                        }
                    }
                }

                docs.push(doc);
            });
        }
        return docs;
    }

    closeDocumentDetails(returnToPath, returnToPreviewPathWizard) {

        const that = this;

        // Para navegar entre contenidos del path es necesario ir elminando la vista detalles del elemento actual antes de dibujar otro
        if (returnToPath) {

            const documentPathId = this.documentationPath.getPathDocumentId();
            const document = this.getDocument(documentPathId);
            const parentFolder = this.getCurrentFolder();

            // Sin el documento del path no se puede redibujar: se cae al cierre normal en vez de lanzar
            // un TypeError que dejaba la pantalla (p. ej. la del test) sin salida.
            if (!document) {
                console.error('closeDocumentDetails: path document not found', documentPathId);

                if (window.Sentry) {
                    Sentry.captureMessage('closeDocumentDetails: path document not found ' + documentPathId);
                }

                this.documentationPath.setReturnToPath(false);
                this.closeDocumentDetails(false, returnToPreviewPathWizard);

                return;
            }

            // La capa actual se retira ya, no al llegar la respuesta: quien dispara el cierre sigue ejecutándose
            // sin esperar, y `closeStack` quita la última capa del momento (podía ser otra ya dibujada).
            baseController.closeSimpleMenu();
            this.documentationPath.deleteKeepTheLoop();
            this.documentationPath.setReturnToPath(false);

            this.documentationPath.getPath(document.path_id, function(pathData) {

                document.pathData = pathData;

                that.drawDocumentDetails(null, document, null, parentFolder);

            });

        } else if (returnToPreviewPathWizard) {

            const documentPathId = this.documentationPath.getPathDocumentId();
            const document = this.getDocument(documentPathId);
            const parentFolder = this.getCurrentFolder();

            this.documentationPath.getPath(document.path_id, function(pathData) {

                document.pathData = pathData;

                baseController.closeSimpleMenu();
                that.documentationPath.setWizardItemIndex(returnToPreviewPathWizard);
                that.drawDocumentDetails(null, document, null, parentFolder);

            });

        } else {

            baseController.closeSimpleMenu();

            const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';
            if (isModuleApp) {
                $('#countdownScreen.stackable').remove()
            }

            if (that.reDrawFolder) {

                const folderIndex = that.folderIndex;
                const documentationContent = $("body");

                // Eliminar el seguimiento por scroll de la vista muro del path
                documentationContent.off("wheel.managePathItemScroll");
                documentationContent.off('touchmove.managePathItemScroll')

                $(".documentation-folders-link[data-folder-index='" + folderIndex + "']").trigger("click");
                that.reDrawFolder = false;

            }

        }

    }

    drawFolder(folder, startFolder = false, isRootFolder = false, startReadingScroll = true, drawFiltersFunction = null) {
        const that = this;

        function _drawFolder() {
            if(!folder) {
                console.warn('Folder empty: ', folder);
            }

            if (folder && (folder.folders || folder.documents)) {
                that.foldersStack.push(folder);

                if (folder.documents) {
                    DocumentationUtils.formatDocParameters(folder);
                }

                let difficultyTimesFormatted = [];
                let difficultyPointsFormatted = [];

                for (let index in world.documentation_difficulties) {
                    difficultyTimesFormatted.push({
                        time: DocumentationUtils.formatCompletedTime(world.documentation_difficulties[index].completion_time),
                        level: world.documentation_difficulties[index].level
                    });
                    difficultyPointsFormatted.push({
                        points: world.documentation_difficulties[index].points.toLocaleString("es-ES"),
                        level: world.documentation_difficulties[index].level
                    });
                }

                that.documentationDifficultyTimes = difficultyTimesFormatted;
                that.documentationDifficultyPoints = difficultyPointsFormatted;

                let advancedView = storage.getItem("documentation-advanced-mode");

                if (advancedView == null || !world.can_change_documentation_view_mode) {
                    if (folder.advanced_view_mode != null) {
                        advancedView = folder.advanced_view_mode;
                    } else if (world.advanced_documentation_view_mode != null) {
                        advancedView = world.advanced_documentation_view_mode;
                    }
                } else {
                    advancedView = advancedView === 'true';
                }

                storage.setItem("documentation-advanced-mode", advancedView);

                if (folder.isResult)
                    folder.total_document_children = folder.documents ? folder.documents.length : 0;

                if (advancedView && folder.documents) {
                    that.drawAdvancedFolder(folder, isRootFolder, difficultyTimesFormatted, difficultyPointsFormatted, that.documentationTags);
                } else {
                    that.drawStandarFolder(folder, isRootFolder, difficultyTimesFormatted, difficultyPointsFormatted, that.documentationTags);
                }

                that.getScreen();
                $(that.screen).find(".toggle-advanced-view-mode[data-folder='" + folder.id + "']").click(function () {
                    that.changeFolderModeView();
                });


                let folderHeaderTitleHeight = 35;

                if ($(window).width() <= 420) {
                    folderHeaderTitleHeight = 30;
                }

                if (!isRootFolder && folder.id !== that.documentation.id) {
                    $(that.screen).find(".documentation-folder-header-title").dotdotdot({
                        wrap: 'word',
                        watch: true,
                        height: folderHeaderTitleHeight,
                    });

                    $(that.screen).find('.documentation-folder-header').show();
                }

                // Eliminar el boton de ir atras si es el comienzo del subarbol de documentos
                if (startFolder || (isRootFolder && folder.folders)) {
                    $(that.screen).find('.documentation-folder-header').remove();
                    $(that.screen).find('#documentation-documents').css('margin-top', 0);
                }

                $(".tintedCanvas").each(function () {
                    tintImage($(this).attr('id'), $(this).attr('data-icon'), $(this).attr('data-color'));
                });

                that.getScreen();
                that.documentationScroll.startScrollManagement(startReadingScroll);

                if (folder.documents) {
                    let docContent = $(that.screen).find(".documentation-content").last();
                    let folderVidAud = docContent.find("video, audio");
                    let audioLevel = storage.getItem("audio-level-documents");
                    let allVidAud = $(that.screen).find("video, audio");
                    let changedMute = allVidAud.length;
                    let counter = 0;

                    if (audioLevel)
                        folderVidAud.prop("muted", audioLevel === 'true');

                    folderVidAud.on("volumechange", function () {
                        if (counter === 0) {
                            let isMuted = $(this).prop("muted");
                            allVidAud.not(this).prop("muted", isMuted);
                            storage.setItem("audio-level-documents", isMuted);
                        }

                        if (++counter === changedMute)
                            counter = 0
                    });
                }
            }

            drawFiltersFunction ? drawFiltersFunction() : null;
        }

        if (this.documentationTags) {
            _drawFolder();
        } else {
            api.getDocumentTags(function (response) {
                that.documentationTags = response.result.tags;
                _drawFolder();
            });
        }
    }

    drawStandarFolder(folder, isRootFolder, difficultyTimesFormatted, difficultyPointsFormatted, documentTags){

        let that = this;
        this.folderModeView = 'standar';

        that.documentationStandarViewPaginator.initialize(folder, isRootFolder, difficultyTimesFormatted, difficultyPointsFormatted, documentTags);

    }

    drawAdvancedFolder(folder, isRootFolder, difficultyTimesFormatted, difficultyPointsFormatted, documentTags){

        let that = this;
        this.folderModeView = 'advanced';

        that.documentationAdvancedViewPaginator.initialize(folder, isRootFolder, difficultyTimesFormatted, difficultyPointsFormatted, documentTags);

    }

    advancedToDetails(e) {
        e.preventDefault();
        documentationScreenController.folderModeView = 'details';
        const docId = $(this).attr('data-resource-id') ? $(this).attr('data-resource-id') : $(this).attr('data-id');
        const doc = documentationScreenController.getDocument(docId);
        const advancedView = storage.getItem("documentation-advanced-mode") === 'true';
        let openDocumentDetailsOption = null;

        // Guardar la posicion del scroll en el momento de acceder a la vista detalles del documento
        documentationScreenController.documentationScroll.lastScrollPosition = $(window).scrollTop();
        documentationScreenController.documentationProgress.stopRead(docId);

        if (['AUDIO', 'VIDEO'].indexOf(doc.type) >= 0) {
            pauseMedia($('.documentation-advanced-documents-row[data-document=' + docId + ']').find(doc.type)[0]);
        }

        if (doc.type === 'GAME') {
            if (doc.own_game.games.length === 0) {
                documentationScreenController.startDocumentTypeGameOrTest(doc, null, null);
                return false;
            }
        }

        if (doc.type === 'POLL') {
            if (doc.own_poll.games.length === 0) {

                documentObj = new DocumentObj(doc, documentationScreenController.foldersStack);

                if (doc.own_poll.games.length === 0) {
                    api.createNewDocumentGame(doc.id);
                    return false;
                } else {
                    this.drawDocumentDetails(null, doc);
                }
            }
        }

        if (doc.type === "PATH") {

            documentationScreenController.documentationPath.getPath(doc.path_id, function(pathData) {

                doc.pathData = pathData;

                const pathModes = documentationScreenController.documentationPath.getPathModes();

                if (pathData.mode === pathModes.WALL_MODE && pathData.coverName === "WALL") {
                    // Antes de entrar en el path cerramos la carpeta con vista muro.
                    $(".documentation-folder-header-back-btn").trigger("click");
                }

                documentationScreenController.drawDocumentDetails(null, doc, null, documentationScreenController.getCurrentFolder());

            });

            return false;

        }

        if ($(this).data('comment')) {
            openDocumentDetailsOption = documentationScreenController.COMMENT_OPTION;
        }

        if ($(this).data('sharing')) {
            openDocumentDetailsOption = documentationScreenController.SHARE_OPTION;
        }

        documentationScreenController.drawDocumentDetails(null, doc, openDocumentDetailsOption);
        return false;
    }

    shortCuts(subType, resourceId, worldToken = null, tabId = null) {
        let that = this;

        // El recurso pertenece a otro mundo. Pero no es un cambio de mundo
        if(worldToken && worldToken !== world.token && subType !== 'QUIZ') {
            // Si no es posible el cambio de mundo -> cerrar sesion -> Pantalla de login (login/register) -> Redirigir al recurso
            this.internalLinkWorld(worldToken, null, function () { return baseController.logout(worldToken); });
            return;
        }

        switch (subType) {
            case 'DOCUMENT':
                if (!that.documentation) {
                    const document = that.getDocument(resourceId);
                    api.getFolderDocuments(document.folder.id, 0, documentationScreenController.documentationPageSize, function(response) {
                        that.documentation = response.result;
                        that.documentationSockets.startNodeConnection();
                        that.goToDocument(resourceId);
                    }, false);
                } else {
                    that.goToDocument(resourceId);
                }
                break;
            case 'TAB':
                let folderId = $('#' + resourceId + '.selected-tab').data('folder-id');
                baseController.selectedTabAction(resourceId, folderId);
                break;
            case 'QUIZ':
                this.internalLinkWorld(resourceId, tabId, function () {
                    if(worldToken) {
                        return baseController.logout(worldToken);
                    } else {
                        swal({
                            title: '',
                            text: Translator.trans('TR_NO_PUEDES_ACCEDER_AL_PROYECTO'),
                            type: "warning",
                            confirmButtonText: Translator.trans('TR_ACEPTAR'),
                            closeOnConfirm: true
                        });
                    }
                });
                break;
            case 'FOLDER':
                api.getFolderDocuments(resourceId, 0, documentationScreenController.documentationPageSize, function(response) {
                    that.internalLinkFolder(response.result, resourceId, null, true);
                });
                break;
            case 'EXTERNAL_URL':
                window.location.href = resourceId;
                break;
        }
    }

    // Abre el documento en vista detalles
    goToDocument(docId) {

        let document = this.getDocument(docId, this.documentation);

        if (document) {

            let parentFolder = this.getParentFolder(document.id, this.documentation, false, true);

            if (document.type === "GAME") {

                if (document.own_game.games.length === 0) {
                    this.startDocumentTypeGameOrTest(document, null, null);
                    return false;
                }

            }

            if (document.type === "POLL") {

                documentObj = new DocumentObj(document, this.foldersStack);

                if (document.own_poll.games.length === 0) {
                    api.createNewDocumentGame(document.id);
                    return false;
                }

            }

            if (document.type === "PATH") {
                this.documentationPath.getPath(document.path_id, (pathData) => {
                    document.pathData = pathData;
                    this.drawDocumentDetails(null, document, null, parentFolder);
                });

                return false;
            }

            this.drawDocumentDetails(null, document, null, parentFolder);

        } else {
            swal({
                title: '',
                text: Translator.trans('TR_DOCUMENTO_NO_ACCESIBLE'),
                type: "warning",
                confirmButtonText: Translator.trans('TR_ACEPTAR'),
                closeOnConfirm: true
            });
        }
    }

    decorateElements() {
        let that = this;
        $('.decorative-element').off().on("click", function (e) {
            let subtype = $(this).data('sub-type');
            let resourceId = $(this).data('resource');
            let tabId = $(this).data('world-tab');  // La pestaña que hay que abrir en caso de enlace a un mundo
            that.shortCuts(subtype, resourceId, null, tabId);
        });
    }

    internalLinkFolder(currentFolder, targetId, docId = null, closeFile = false, startFolder) {
        let that = this;

        // Si el current folder esta vacio -> El usuario no tiene permisos para acceder a la carpeta. MOSTRAR ALERT
        if (!currentFolder && targetId != documentationScreenController.documentation.id) {
            swal({
                title: '',
                text: Translator.trans('TR_CARPETA_NO_ACCESIBLE'),
                type: "warning",
                confirmButtonText: Translator.trans('TR_ACEPTAR'),
                closeOnConfirm: true
            });
            return;
        }

        if (that.foldersStack.length > 0) {
            //what?
            // var popedfolder = that.foldersStack.pop();
            // that.foldersStack.push(popedfolder);

            // do you want to get the last item?
            var popedfolder = that.foldersStack[that.foldersStack.length -1];

            // Si la carpeta lincada es la misma que la actual, mostrar alerta
            if(popedfolder && popedfolder.id === currentFolder.id) {

                //little hack
                // $(".documentation-folder-header-back-btn").click();

                swal({
                    title: '',
                    text: Translator.trans('TR_CARPETA_ACTUAL'),
                    type: "warning",
                    confirmButtonText: Translator.trans('TR_ACEPTAR'),
                    closeOnConfirm: true
                });
                return;
            }

            if(closeFile)
                $('#documentation-header-close-btn').trigger('click');
        }

        // No mostrar el contenido de la carpeta si esta vacia
        if(currentFolder.folders || currentFolder.documents) {
            that.drawFolder(currentFolder, startFolder);

            return currentFolder;

        }

        console.error('returning null');
        return null;
    }

    internalLinkWorld(worldId, tabId = null, errorCallback = null, successCallback = null) {

        if (!user) {
            errorCallback ? errorCallback() : null;
            return;
        }

        let worldsToken = user.tokens;
        let userWorldToken = worldsToken.filter(function (token) {return token.world_id == worldId || token.token === worldId})[0];

        if(userWorldToken) {
            ChangeQuizController.closeQuiz(userWorldToken.access_token, userWorldToken.token, tabId, successCallback);
        } else {
            errorCallback ? errorCallback() : null;
        }
    }

    getTabName(tabId) {
        let tabs = world.world_tabs;
        let tabName = '';
        Object.keys(tabs).forEach(function (key) {
            if (tabs[key].world_tab_id === tabId) {
                tabName = tabs[key].name;
            }
        });
        return tabName;
    }

    changeSelectedTab(tab_id) {
        $('.nav-tabs').each(function (e) {
           if ($(this).find('a').attr('id') === tab_id) {
               $(this).addClass("active");
           }
        })
    }

    getCurrentFolder() {
        let currentFolder = this.foldersStack.pop();
        this.foldersStack.push(currentFolder);
        return currentFolder;
    }

    showFolderInfo(folder) {
        let template = Handlebars.compile($("#documentationFolderInfoModal").html());
        $("#modalContainer").html(template(folder)).modal('show');

        $(document).one('click', '.modal-close-btn, .modal-accept-btn', function () {
            $("#modalContainer").modal('hide').empty();
            $(document).off('click', '.modal-close-btn, .modal-accept-btn');
        });
    }

    getDocumentIndex(documentId, checkFilter = false, currentFolder = null) {
        if(checkFilter){
            let activeFilters = $(this.screen).find('.filterEnabled');
            let searchTerm = $(this.screen).find('.documentation-searchbar').val();

            if((activeFilters && activeFilters.length > 0) || (searchTerm && searchTerm.length > 0))
                currentFolder = documentationScreenController.getParentFolder(documentId, documentationScreenController.documentation);
        }

        if(!currentFolder)
            currentFolder = this.getCurrentFolder();

        let index = -1;

        // Buscar documentos
        if(currentFolder && currentFolder['documents']){
            documentId = parseInt(documentId);
            currentFolder['documents'].some(function(el, i) {
                if (el.id === documentId) {
                    index = i;
                    return true;
                }
            });
        }

        // Buscar carpetas
        if(currentFolder && currentFolder['folders']){
            documentId = parseInt(documentId);
            currentFolder['folders'].some(function(el, i) {
                if (el.id === documentId) {
                    index = i;
                    return true;
                }
            });
        }

        if(index !== -1)
            return index;

        return null;
    }

    drawDocumentDetailsWithDocumentId(documentId, parentFolder = null) {
        let document = this.getDocument(documentId);

        DocumentationUtils.formatDocumentParameters(document, parentFolder);

        this.drawDocumentDetails(
            null,
            document,
            null,
            parentFolder ?? null
        );
    }

    drawDocumentDetails(link, doc=null, openOption=null, parentFolder=null, openOnlyDrawer = false) {
        ga('send', 'pageview', analytics.GA_SCREEN_SHOW_DOCUMENT_FILE);

        this.folderModeView = 'details';

        var url = doc ? doc.url : link.attr('href');
        var type = doc ? doc.type : link.attr('data-type');
        var icon = doc ? doc.icon : link.attr('data-icon');
        var documentId = doc ? doc.id : link.attr('data-id');

        let that = this;
        let folder = parentFolder ? parentFolder : this.getCurrentFolder();
        let document = null;

        if (!doc) {
            // Es un enlace a un documento. Mirar donde está el documento al que referencia desde ROOT.
            document = this.getDocument(documentId);
        } else {
            // Force an object clone
            // spread object doesn't work ({...doc})
            document = JSON.parse(JSON.stringify(doc));
        }

        let fullScreenHeader = true;
        let documentDuration = null;
        let isSharing = doc ? doc.is_shared : link.data('sharing');
        let isComment = doc ? doc.comments.length>0 : link.data('comment');
        let advancedView = storage.getItem("documentation-advanced-mode") === 'true';
        let currentAdvancedDoc = this.getDocument(this.documentationScroll.currentReadingDocument);

        if(document.media_duration && (document.type === "VIDEO" || document.type === "AUDIO")){
            documentDuration = DocumentationUtils.formatCompletedTime(document.media_duration);
        } else if(document.time_completable_total && document.type !== "GALLERY") {
            documentDuration = DocumentationUtils.formatCompletedTime(document.time_completable_total);
        } else if (document.type === "URL") {
            if (document.content_external && document.content_external.rel.indexOf("playerjs") >= 0 && document.content_external.duration) {
                documentDuration = DocumentationUtils.formatCompletedTime(document.content_external.duration);
            } else if (document.time_completable_total) {
                documentDuration = DocumentationUtils.formatCompletedTime(document.time_completable_total);
            }
        }

        if(document.created_at){
            document.created_at_formmated = formatToDateSystem(document.created_at);
        }

        let commentsAmount = DocumentationUtils.formatKMnumber(document.total_comments);
        let pointsAmount = document.completed_points ? DocumentationUtils.formatKMnumber(document.completed_points) : null;
        let showTestButton = true;

        if (world.shows_completion && !document.completed) {
            showTestButton = false;
        }

        if(document.rating_average)
            document.rating_selected = DocumentationUtils.getSelectedRating(document);

        let docTags = null;
        if(document.tags)
            docTags = document.tags.split(",");

        if (document.type === "PATH") {
            document.progressState = that.documentationProgress.getPathProgressState(document);
            if (!document.question_category) {
                document.question_category = {
                    title: Translator.trans("TR_GENERAL")
                }
            }
        } else {
            document.progressState = that.documentationProgress.getProgressState(document);
        }

        document.location = that.documentsRoutes[documentId];
        document.external = document.external && !DocumentationUtils.isSpecialDocument(document.type);

        if (document.type === 'GAME' && (document?.own_game.games || []).length > 0) {
            document.own_game.total_points = _.sumBy(document.own_game.games, "total_points");
            document.own_game.last_game = _.maxBy(document.own_game.games, function(game) { return game.end_date });
            document.own_game.is_button_visible = document.own_game.num_tries - document.own_game.games.length > 0 || !document.own_game.num_tries;
        }

        if (document.type === 'TEST' && (document?.own_test.games || []).length > 0) {
            document.own_test.best_game = _.maxBy(document.own_test.games, function(game) { return game.qualification });
            document.own_test.last_game = _.maxBy(document.own_test.games, function(game) { return game.end_date });
        }

        if (document.type === "HTML" && !document.external) {
            fullScreenHeader = false;
        }

        let currentFolder = that.getCurrentFolder();

        baseController.stackSimpleMenu({
            title: '',
            icon: document.type === "GAME" ? "bf-close" : "close",
            fullScreenHeader: fullScreenHeader,
            documentType: document.type,
            withoutHeader: true
        }, that.singleMenuTemplate);

        // showPathScreen lo marca al apilar el HTML del path y avisa a `afterPathScreenDrawn`: initialize()
        // registra los clics sobre ese DOM, así que solo puede ejecutarse una vez dibujado (una única petición getPath).
        let pathScreenDrawn = false;
        let afterPathScreenDrawn = null;

        const renderStack = () => {
            // console.warn("Rendering Stack...");
            let customScreenTemplate =  that.documentDetailsTemplate;

            if($(window).width() >= 1280) {
                //custom template only for desktop (desktop updates 2023)
                if (document.type === "PATH") {
                    customScreenTemplate = Handlebars.compile($("#worldDocumentationDetailScreenDesktopPath").html());
                } else {
                    customScreenTemplate = Handlebars.compile($("#worldDocumentationDetailScreenDesktop").html());
                }
            }

            const showPathScreen = () => {
                baseController.stackSimpleContent(customScreenTemplate, {
                    user: user,
                    world: world,
                    folder: folder,
                    showTestButton: showTestButton,
                    document: document,
                    documentDuration: documentDuration,
                    pointsAmount: pointsAmount,
                    commentsAmount: commentsAmount,
                    docTags: docTags,
                    url: url,
                    isWebsite: DocumentationUtils.isWebsite(document),
                    documentMatch: finderController.documentMatch,
                    withoutHeader: true,
                    navigationIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_FAVORITE"],
                    chatShareIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_SHARE_CHAT"],
                    sharedIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_SHARE"],
                    playIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_PLAY"],
                    commentsIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_COMMENT"],
                    rateIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_RATE"],
                    docTestIcon: customIcons["DOCUMENTATION_TEST_ICON"],
                    smile0Icon: customIcons["RATE_SMILE_0"],
                    smile1Icon: customIcons["RATE_SMILE_1"],
                    newFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_NEW"],
                    favouriteFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_FAVORITE"],
                    chatTabEnabled: $('.chatTab').length > 0,
                    pathModes: document.type === "PATH" ? this.documentationPath.getPathModes() : null,
                    socialActivityTypes: new SocialActivitiesTypes().getTypes(),
                    openOnlyDrawer: openOnlyDrawer
                });
                pathScreenDrawn = true;

                if (afterPathScreenDrawn) {
                    afterPathScreenDrawn();
                    afterPathScreenDrawn = null;
                }
            }
            const isModuleApp = window.reactZustandBridge && world?.mode === 'newLayout';
            if (isModuleApp && document.type === "PATH") {
                that.documentationPath.getPath(document.path_id, (response) => {
                    document.pathData = response;
                    showPathScreen();
                });
            } else {
                showPathScreen();
            }
        };

        const isAvailableForResize = () => {
            return  window.document.querySelectorAll(
                [
                    '#documentationDetailSection .wrapper',
                    '#documentationDetailSection .wrapper-desktop',
                    '#documentationDetailSection .wrapper-desktop-path',
                ]
            ).length > 0;
        }

        // Re-render when window is resized
        $(window).resize(() => {
            const availableResize = isAvailableForResize();

            if (availableResize) {
                window.document.querySelector('body').style.opacity = 0;
            }
        });

        $(window).resize(_.debounce(() => {
            const availableResize = isAvailableForResize();

            const mobileBreakpoint = 1280;
            const currentWidth = $(window).width();

            const wasMobile = window.previousWidth < mobileBreakpoint;
            const wasDesktop = !wasMobile;

            const deservesRerender = (wasMobile && currentWidth > mobileBreakpoint) ||
                (wasDesktop && currentWidth < mobileBreakpoint);
            const doesNotRequireResize = ['URL'].includes(document.type);

            /** Execute a re-render when the window is resized */
            if (availableResize && !doesNotRequireResize && deservesRerender) {
                baseController.closeStack();
                this.drawDocumentDetails(link, doc, openOption, parentFolder, openOnlyDrawer);

                setTimeout(() => {
                    window.document.querySelector('body').style.removeProperty('opacity');
                }, 50);
            } else {
                window.document.querySelector('body').style.removeProperty('opacity');
            }
        }, 800));

        renderStack();
        window.previousWidth = $(window).width();

        $(".background-icon").each(function () {
            let iconTitle = 'RATE_SMILE_' + $(this).data('rating');
            $(this).css('background-image', 'url(' + customIcons[iconTitle] + ')');
        });

        that.currentDocumentDetails = document;

        let isMultimedia =  currentAdvancedDoc ? DocumentationUtils.isMultimediaDocument(currentAdvancedDoc.type) : false;
        let documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;

        // Si se ha abierto el documento desde chat quitar el background blanco de la sala de chat
        if (documentOpenedInChat) {
            $('.quiz-wrapper').removeClass('chat-messages-wrapper');
        }

        $("#smile-document").attr('src', customIcons["RATE_SMILE_" + document.rating_selected]);

        if(documentDuration !== null && documentDuration.split(":").length == 3)
            $(".documentInfoBar").addClass("infoBarHours");

        DocumentationUtils.initDetailCanvas(folder?.id, document, isComment);

        if(typeof(document.new) == 'undefined' || document.new == null || document.new) {
            if (!document.isPathTestContent && !document.isPathGameContent) {
                if (!docSocket) {
                    docSocket = api.quizSoquet();
                }

                docSocket.emit(SocketEvents.REMOVE_NEW_REQUEST(), JSON.stringify({document_id: document.id}));
            }
        }

        $(".tintedDetailsCanvas").each(function () {
            tintImage($(this).attr('id'), $(this).attr('data-icon'), $(this).attr('data-color'));
        });

        // button test
        $('.doc-details-test-button-container > .action-button').click(_.debounce(function() {
            let pathDocument = null;

            if (document.isPathTestContent) {
                const pathDocumentId = that.documentationPath.getPathDocumentId();
                pathDocument = that.getDocument(pathDocumentId);

                // Set in progress (events)
                that.documentationProgress.setInProgress(document.id);
            }

            that.startDocumentTypeGameOrTest(null, document, pathDocument);
        }, 500));

        $('.mark-favourite').click(function (e) {
            e.preventDefault();
            ga('send', 'event', analytics.GA_CATEGORY_DOCUMENTATION, analytics.GA_CATEGORY_DOCUMENTATION_EVENT_MAKE_FAVOURITE, document.id);
            docSocket.emit(SocketEvents.SET_FAVORITE_REQUEST(), JSON.stringify({document_id: document.id}));
        });

        $(".mark-liked").on("click.markAsILiked", function(e) {

            e.preventDefault();

            const documentId = $(this).data("document");
            const gifDocumentLiked = $("#gif-document-liked-" + documentId + "-details");

            // Prevenir error al pulsar varias veces seguidas y rapido sobre el boton de like.
            if (gifDocumentLiked.children().length === 0) {
                docSocket.emit(SocketEvents.SET_LIKE_REQUEST(), JSON.stringify({document_id: $(this).data("document")}));
            }

        });

        $('.chat-share-document-details').click(function() {
            that.documentationShareChat.initChatShareSection(folder.id, document.id);
        });

        $(".doc-details-edit-button").on("click.editDocument", this.documentationPublish.goToEdition.bind(this.documentationPublish));
        $(".social-activity-button").on("click.showDataList", this.drawDocumentUsersSocialActivityScreen.bind(this));

        // Ocultar el boton del finder al entrar en la vista detalles
        $('#open-finder-button').hide();

        if (document.type === 'IMAGE') {

            const wrapperSelector = $('#documentationDetailSection .doc-details-image-container');
            const defaultImageSelector = $('.doc-details-IMAGE');   // Contiene la imagen ajustada al contenedor (reducida)

            // initialize cursor zoom
            if($(window).width() < 1280) {
                defaultImageSelector.addClass('cursor-zoom-in');
            } else {
                defaultImageSelector.removeClass('cursor-zoom-in');
            }

            // only launch if we are in mobile version
            if ($(window).width() < 1280) {
                const zoomImageSelector = $('.doc-details-image-zoom'); // Contiene la imagen sin restricciones de tamanyo (original)

                defaultImageSelector.click('click.ZoomInImage', function() {

                    // Solo realizar zoom si la imagen es originalmente mas grande que el contenedor
                    if (zoomImageSelector[0].naturalWidth > wrapperSelector.width() || zoomImageSelector[0].naturalHeight > wrapperSelector.height()) {

                        // Occultar la imagen reducida  y mostrar la original
                        zoomImageSelector.removeClass('d-none');
                        defaultImageSelector.addClass('d-none');
                        wrapperSelector.addClass('zoom');

                        // Ocultar la imagen original y mostrar la reducida
                        zoomImageSelector.one('click.ZoomOutImage', function () {

                            zoomImageSelector.addClass('d-none');
                            defaultImageSelector.removeClass('d-none');
                            wrapperSelector.removeClass('zoom');

                        });
                        // Si la imagen es mas pequenya o igual que el contenedor unicamente cambiar el cursor
                    } else {
                        if (defaultImageSelector.hasClass('cursor-zoom-in')) {
                            defaultImageSelector.removeClass('cursor-zoom-in').addClass('cursor-zoom-out');
                        } else {
                            defaultImageSelector.removeClass('cursor-zoom-out').addClass('cursor-zoom-in');
                        }
                    }
                });
            }
        }

        if (document.type === "URL") {
            api.checkDocumentationLink(document.url, function(response) {

                const openModalButton = $("div.open-modal-btn");
                const external = $("div.external");
                const isWebsite = DocumentationUtils.isWebsite(document);
                const showWithIframe = response.result;

                if (external.length > 0) {

                    if (isWebsite && showWithIframe) {
                        external.html("<iframe class='doc-details-URL' src='" + document.url + "' frameborder='0'></iframe>");
                        external.removeClass("overflow-auto");
                        openModalButton.show();
                    } else if (isWebsite) {
                        external.html(document.content_external.html);
                        external.addClass("overflow-auto");
                    } else {
                        external.html("<div>" + document.content_external.html + "</div>");
                        external.addClass("overflow-auto");
                    }

                    const externalContainer = $("div.external > div");

                    if (!external.hasScrollBar()) {
                        externalContainer.addClass("vcenter-relative");
                    } else {
                        externalContainer.removeClass("vcenter-relative");
                    }

                }

                // IZE-9531 (paridad con Vídeo/Audio, FR-021): ya no se llama a `startRead`
                // incondicionalmente al abrir el contenido externo. `setCompleteness` resuelve el
                // submodo (EXTERNAL_BY_CONFIRMATION/PLAYBACK_END/TIME/ACCESS) y es quien decide si
                // el tracking arranca ya mismo o se difiere al primer `play` del reproductor
                // embebido (solo en EXTERNAL_BY_PLAYBACK_END, ver DocumentationProgress.js).
                that.documentationProgress.setCompleteness(document.id);

            });

        }

        $('#documentation-header-open-modal-btn, #open-modal-btn').click(function(){

            const template = Handlebars.compile($("#iframeModal").html());

            var context = {
                url: url,
                type: type,
            };

            $('#modalContainer').html(template(context)).modal('show');
            $('#modalContainer').addClass('full-screen-modal');

            $('.modal-close-btn').one('click', function() {

                $('#modalContainer').removeClass('full-screen-modal');
                $("#modalContainer").modal('hide').empty();

            });

        });

        const documentDetailsToggleButtonIcon = $("#document-details-toggle-button-icon");
        tintImage(documentDetailsToggleButtonIcon.attr("id"), documentDetailsToggleButtonIcon.attr("data-icon"), "DBDBDB");

        $(window).off("resize.manageDetailsToggleButton").on("resize.manageDetailsToggleButton", function() {
            that.manageDocumentDetailsToggleButton(document, documentDetailsToggleButtonIcon);
        });

        if (['GALLERY', 'DECO_GALLERY'].indexOf(document.type) >= 0) {
            let imgCarousel = $(".owl-carousel-details");

            that.adjustImageCarousel(imgCarousel);
        }

        $(".tintedCanvas").each(function () {
            tintImage($(this).attr('id'), $(this).attr('data-icon'), $(this).attr('data-color'));
        });

        // Este caso de completitud se lanzara tras comprobar la url con un endpoint para saber si se puede poner o no como iframe el recurso.
        // if (document.type !== "URL" && !document.isPathTestContent && !document.isPathGameContent && !document.isPathWizardPreviewContent) {
        // IZE-9629 (FR-021): Vídeo y Audio quedan excluidos de este arranque genérico — su inicio de
        // seguimiento se dispara al empezar a reproducir, no al abrir el documento (ver
        // DocumentationProgress.js::setCompletenessByMedia).
        // IZE-9629: Learning Path (SPECIAL) también queda excluido — no debe generar su propio ciclo
        // de tracking genérico (start/update/stop); solo se marca en progreso localmente (ver abajo).
        // IZE-9531 (bug encontrado en pruebas manuales, 2026-09-10): GAME/TEST/POLL también quedan
        // excluidos — completan por su propio ciclo (new-game/register), no por start/update/stop
        // genérico (ver DocumentationProgress.js::setCompleteness, que ya no engancha ningún
        // setCompletenessBy* para estos tres tipos, pero este startRead incondicional los alcanzaba
        // igualmente por no estar en la lista de exclusión).
        if (document.type !== "URL" && document.type !== "VIDEO" && document.type !== "AUDIO" && document.type !== "PATH" && document.type !== "GAME" && document.type !== "TEST" && document.type !== "POLL" && !document.isPathWizardPreviewContent) {
            that.documentationProgress.startRead(document.id);
        }

        // if (document.type === 'PATH') {
        //     that.documentationProgress.setInProgress(document.id);
        // }

        if (document.type === "VIDEO" || document.type === "AUDIO") {

            const media = $('#documentationDetailSection').find(document.type)[0];
            const timeToMatch = 3;

            if (finderController.documentMatch) {
                media.currentTime = _.max([0, finderController.documentMatch - timeToMatch]);
            }

            // IZE-9629 (FR-021): enlaza aquí los listeners play/pause/ended (setCompletenessByMedia),
            // ya que `startRead` para estos dos tipos se difiere hasta el primer `play` y por tanto no
            // los enlaza por sí solo (ver exclusión de `startRead` más arriba en este método).
            that.documentationProgress.setCompleteness(document.id);
        }

        if (document.type === "GAME") {
            //action button: game
            $(".game-button-container > .action-button").on("click.goToGame", _.debounce(function() {
                if (document.own_game.belonging_to_path_id) {
                    that.startDocumentTypeGameOrTest(document, null, that.getDocument(document.own_game.belonging_to_path_id));
                    that.documentationProgress.setInProgress(document.id);

                    return;
                }

                that.startDocumentTypeGameOrTest(document, null, null);
            }, 500));

            // La vista detalles del test del path no debe tener ficha ni barra de acciones.
            if (document.isPathGameContent) {
                $(".bottomOptionsBar.documentation-details").remove();
                $(".doc-cover-GAME, .doc-details-game").addClass("is-path-game-content");
                DocumentationUtils.calcDetailsViewHeight();
            }

            if (document.completed) {
                this.documentationProgress.setCompleted(document.id);
            }

            if (document.own_game.games.length > 0) {

                document.own_game.last_game.show_points = false;

                api.getChartToken(function (responseToken) {

                    const template = Handlebars.compile($("#documentTypeGameTabsFragment").html());
                    let context = {}

                    if (api.checkisValidResult(responseToken)) {

                        const detailsScreenHeight = $('.doc-details-GAME').height();
                        const headerHeight = $('.doc-details-GAME .cover-header').outerHeight();
                        const resultsHeight = $('.doc-details-GAME .information-box ').outerHeight();

                        if (document.own_game.game_mode === "SINGLE") {
                            context = {
                                document: document,
                                world: world,
                                user: user,
                                token: responseToken.token
                            }
                            $("#doc-details-game-tabs .tab-content").html(template(context));
                            $('#mymap').height(detailsScreenHeight - headerHeight - resultsHeight);
                        } else {
                            api.getDocumentGameRanking(documentId, 10, function (response) {
                                if (api.checkisValidResult(response)) {
                                    context = {
                                        document: document,
                                        world: world,
                                        user: user,
                                        token: responseToken.token,
                                        ranking: response.result.ranking,
                                        position: response.result.position
                                    }
                                    $("#doc-details-game-tabs .tab-content").html(template(context));
                                    $("#doc-details-game-tabs .my-map-nav-item").removeClass("active");
                                    $("#doc-details-game-tabs .top-10-nav-item").addClass("active");
                                    $(".ranking-stats .middle-column > span, .doc-game-results .position span").text(response.result.position + 'º');
                                    $('#mymap').height(detailsScreenHeight - headerHeight - resultsHeight);
                                    document.own_game.user_rank = response.result.position;
                                }
                            });
                        }

                        $(window).resize(function () {
                            const detailsScreenHeight = $('.doc-details-GAME').height();
                            const headerHeight = $('.doc-details-GAME .cover-header').outerHeight();
                            const resultsHeight = $('.doc-details-GAME .information-box ').outerHeight();
                            $('#mymap').height(detailsScreenHeight - headerHeight - resultsHeight);
                        });
                    }
                });
            }

        }

        that.manageDocumentDetailsToggleButton(document, documentDetailsToggleButtonIcon);
        that.manageDocumentDetailsRate(document, openOption);
        that.manageDocumentationDetailsComments(document, isComment, openOption);
        that.manageDocumentationDetailsShare(folder, document, isSharing, openOption);
        that.manageDocumentViews(document);
        that.manageDocumentActiviy(document);
        that.carouselClick();

        DocumentationUtils.drawTestPieChart($("#current-doc-pie-chart"));

        if (document.type === "TEST") {

            // La vista detalles del test del path no debe tener ficha ni barra de acciones.
            if (document.isPathTestContent) {
                $(".bottomOptionsBar.documentation-details").remove();
                $(".doc-details-TEST").addClass("is-path-test-content");
                DocumentationUtils.calcDetailsViewHeight();
            }

            const totalHeight = $('#documentationDetailSection').height();
            const resultsHeight = $('.doc-details-TEST .results-container').outerHeight();
            const marginSpace = 25;

            $('.doc-details-TEST .image-container ').height(totalHeight - resultsHeight - marginSpace);

            $(window).off('resize.testImage').on('resize.testImage', function() {

                const totalHeight = $('.doc-details-TEST').height();
                const resultsHeight = $('.doc-details-TEST .results-container').outerHeight();
                const marginSpace = 25;

                $('.doc-details-TEST .image-container ').height(totalHeight - resultsHeight - marginSpace);

            });
        }

        if (document.type === "POLL") {
            $('.doc-details-poll-button').off().one('click.openPollResults', _.debounce(function() {
                if (document.own_poll.games.length === 0) {
                    documentObj = new DocumentObj(document, that.foldersStack);
                    api.createNewDocumentGame(document.id);
                }
            }, 500));
        }

        if (document.type === "PATH") {
            const showPathDetailsScreen = () => {
                const pathData = this.documentationPath.getPathData();
                const pathModes = this.documentationPath.getPathModes();
                const lastYScrollPosition = this.documentationPath.getLastYScrollPosition();
    
                that.documentationPath.initialize(document.id);
                smartListsController.initialize();
    
                //instagram mode
                if (pathData.mode === pathModes.WALL_MODE && pathData.coverName === "WALL") {
                    this.documentationScroll.startPathScrollManagement(true);
    
                    //initialize carousel
                    const folder = pathData?.document_root?.folder;
                    this.setCarouselConfig(folder, false);
                    this.setAdvancedDocumentsConfig();
                    this.setAdvancedViewEvents(folder);
                    this.decorateElements();
    
                    //initialize wall
                    this.manageDocumentViews(document);
                    this.manageDocumentActiviy(document);
                    // IZE-9629: Learning Path (SPECIAL) queda excluido — no debe generar su propio
                    // ciclo de tracking genérico (start/update/stop); solo se marca en progreso localmente.
                    this.documentationProgress.setInProgress(document.id);
                }
            }

            const isModuleApp = window.reactZustandBridge && world?.mode === 'newLayout';
            if (isModuleApp) {
                // renderStack ya hace el getPath y dibuja al responder: aquí solo se espera a ese dibujado.
                if (pathScreenDrawn) {
                    showPathDetailsScreen();
                } else {
                    afterPathScreenDrawn = showPathDetailsScreen;
                }
            } else {
                showPathDetailsScreen();
            }
        }

        if (document.isPathClassContent) {
            // Deja un poco de tiempo antes de hacer la animación para verla completa y fluida.
            setTimeout(function() {
                that.documentationPath.showKeepTheLoop();
            }, 500);
        }

        if (document.isPathWizardPreviewContent) {

            const pathUtils = this.documentationPath.getPathUtils();

            pathUtils.setPathWizardItemPreviewEllipsis()
            pathUtils.setPathWizardItemPreviewStyles();

            this.documentationPath.enableWizardPreviewHandlers();

            document.isPathWizardPreviewContent = false;

            // IZE-9629 (FR-013): la completitud del path la resuelve backend al persistir cada
            // contenido hijo; el frontend solo refresca el path ya persistido. Se mantiene la guarda
            // `_.every(..., "completed")` como optimización para evitar un refresco de red innecesario
            // mientras aún falten contenidos por completar.
            if (_.every(document.pathWizardPreviewNavData.items, "completed")) {
                this.documentationPath.checkAndRefreshPathCompletion(document.path_id, this.documentationPath.getPathDocumentId());
            }

        }

        if (document.pathData && document.pathData.monoModeClassDocument) {

            const pathUtils = this.documentationPath.getPathUtils();
            pathUtils.setPathMonoDocumentData(document.pathData.monoModeClassDocument);

        }

        this.getCompletedDocumentUsers(document.id, function(response) {

            DocumentationUtils.formatDocumentCompletedUsers(document, response);

            let completenessTitle = "";

            if (document.type === "GAME") {
                completenessTitle = Translator.trans("TR_ESTAN_JUGANDO");
            } else {
                completenessTitle = Translator.trans("TR_LO_HAN_COMPLETADO");
            }

            const container = $(".document-completed-users");
            const context = {
                world: world,
                document: document,
                completenessTitle: completenessTitle
            };

            container.html(that.userCompletenessIndicatorTemplate(context));

            if (document.type === "PATH") {
                $(".doc-details-PATH .completed-label").remove();
            }

        });

        $("#document-details-content .nav-link").on("click.selectedTab", function(e) {

            const tabName = $(this).attr("aria-controls");
            const commentsTabSelected = $("#document-details-content div.comments-tab").hasClass("active");

            // Al pulsar sobre la pestaña comentarios si no esta abierto ya el input de comentar abrirlo
            if (tabName === "comments" && !$(".openCommentButton").hasClass("world_color_1_bg")) {
                that.sendDetailsComment(document);
                return false;
            }

            // Al pulsar sobre otra pestaña si estaba abierto el input de comentar cerrarlo
            if ($(".openCommentButton").hasClass("world_color_1_bg") && (tabName === "information" || tabName === "activity")) {
                $("#documentComment-" + documentId + "-details").trigger("click");
            }

        });

    }

    /**
     * Render Drawer in bottom.
     * @param link
     * @param doc
     * @param openOption
     * @param parentFolder
     * @param render
     */
    renderDrawerBottom(link, doc=null, openOption=null, parentFolder=null, render = null) {
        this.documentDetailsTemplateReact = Handlebars.compile($("#worldDocumentationDetailScreenReact").html());
        this.folderModeView = 'details';

        var url = doc ? doc.url : link.attr('href');
        var type = doc ? doc.type : link.attr('data-type');
        var documentId = doc ? doc.id : link.attr('data-id');

        let that = this;
        let folder = parentFolder ? parentFolder : this.getCurrentFolder();
        let document = doc;

        if (!document) {
            // Es un enlace a un documento. Mirar donde está el documento al que referencia desde ROOT.
            document = this.getDocument(documentId);
        }

        let isSharing = doc ? doc.is_shared : link.data('sharing');
        let isComment = doc ? doc.comments.length>0 : link.data('comment');

        // show the total time to complete the task
        //time_completable_total
        const documentDuration = DocumentationUtils.formatCompletedTime(
            document.completed_time || document.media_duration || 0
        );

        if(document.created_at){
            document.created_at_formmated = formatToDateSystem(document.created_at);
        }

        let commentsAmount = DocumentationUtils.formatKMnumber(document.total_comments);
        let pointsAmount = document.completed_points ? DocumentationUtils.formatKMnumber(document.completed_points) : null;
        let showTestButton = true;

        if (world.shows_completion && !document.completed) {
            showTestButton = false;
        }

        if(document.rating_average)
            document.rating_selected = DocumentationUtils.getSelectedRating(document);

        const docTags = document.tags ? document.tags.split(",") : null;
        document.progressState = that.documentationProgress.getProgressState(document);
        document.location = that.documentsRoutes[documentId];
        document.external = document.external && !DocumentationUtils.isSpecialDocument(document.type);

        const ctx = {
            user: user,
            world: world,
            folder: folder,
            showTestButton: showTestButton,
            document: document,
            documentDuration: documentDuration,
            pointsAmount: pointsAmount,
            commentsAmount: commentsAmount,
            docTags: docTags,
            url: url,
            isWebsite: DocumentationUtils.isWebsite(document),
            documentMatch: finderController.documentMatch,
            withoutHeader: true,
            navigationIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_FAVORITE"],
            chatShareIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_SHARE_CHAT"],
            sharedIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_SHARE"],
            playIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_PLAY"],
            commentsIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_COMMENT"],
            rateIcon: customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_RATE"],
            docTestIcon: customIcons["DOCUMENTATION_TEST_ICON"],
            smile0Icon: customIcons["RATE_SMILE_0"],
            smile1Icon: customIcons["RATE_SMILE_1"],
            newFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_NEW"],
            favouriteFilterIcon: customIcons["DOCUMENTATION_TOOLBAR_FILTER_FAVORITE"],
            chatTabEnabled: $('.chatTab').length > 0,
            pathModes: document.type === "PATH" ? this.documentationPath.getPathModes() : null,
            socialActivityTypes: new SocialActivitiesTypes().getTypes(),
        };

        if(render) {
            render(this.documentDetailsTemplateReact(ctx));
        }

        $(".background-icon").each(function () {
            let iconTitle = 'RATE_SMILE_' + $(this).data('rating');
            $(this).css('background-image', 'url(' + customIcons[iconTitle] + ')');
        });

        that.currentDocumentDetails = document;

        let documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;

        // Si se ha abierto el documento desde chat quitar el background blanco de la sala de chat
        if (documentOpenedInChat) {
            $('.quiz-wrapper').removeClass('chat-messages-wrapper');
        }

        $("#smile-document").attr('src', customIcons["RATE_SMILE_" + document.rating_selected]);

        if(documentDuration !== null && documentDuration.split(":").length == 3)
            $(".documentInfoBar").addClass("infoBarHours");

        DocumentationUtils.initDetailCanvas(folder?.id, document, isComment);

        $(".tintedDetailsCanvas").each(function () {
            tintImage($(this).attr('id'), $(this).attr('data-icon'), $(this).attr('data-color'));
        });

        $('.mark-favourite').click(function (e) {
            e.preventDefault();
            ga('send', 'event', analytics.GA_CATEGORY_DOCUMENTATION, analytics.GA_CATEGORY_DOCUMENTATION_EVENT_MAKE_FAVOURITE, document.id);
            docSocket.emit(SocketEvents.SET_FAVORITE_REQUEST(), JSON.stringify({document_id: document.id}));
        });

        $(".mark-liked").on("click.markAsILiked", function(e) {
            e.preventDefault();

            const documentId = $(this).data("document");
            const gifDocumentLiked = $("#gif-document-liked-" + documentId + "-details");

            // Prevenir error al pulsar varias veces seguidas y rapido sobre el boton de like.
            if (gifDocumentLiked.children().length === 0) {
                docSocket.emit(SocketEvents.SET_LIKE_REQUEST(), JSON.stringify({document_id: $(this).data("document")}));
            }
        });

        $('.chat-share-document-details').click(function() {
            that.documentationShareChat.initChatShareSection(folder.id, document.id);
        })

        $(".doc-details-edit-button").on("click.editDocument", this.documentationPublish.goToEdition.bind(this.documentationPublish));
        $(".social-activity-button").on("click.showDataList", this.drawDocumentUsersSocialActivityScreen.bind(this));

        // Ocultar el boton del finder al entrar en la vista detalles
        $('#open-finder-button').hide();

        $('#documentation-header-open-modal-btn, #open-modal-btn').click(function(){
            const template = Handlebars.compile($("#iframeModal").html());

            var context = {
                url: url,
                type: type,
            };

            $('#modalContainer').html(template(context)).modal('show');
            $('#modalContainer').addClass('full-screen-modal');

            $('.modal-close-btn').one('click', function() {
                $('#modalContainer').removeClass('full-screen-modal');
                $("#modalContainer").modal('hide').empty();

            });
        });

        const documentDetailsToggleButtonIcon = $("#document-details-toggle-button-icon");
        tintImage(documentDetailsToggleButtonIcon.attr("id"), documentDetailsToggleButtonIcon.attr("data-icon"), "DBDBDB");

        $(window).off("resize.manageDetailsToggleButton").on("resize.manageDetailsToggleButton", function() {
            that.manageDocumentDetailsToggleButton(document, documentDetailsToggleButtonIcon);
        });


        $(".tintedCanvas").each(function () {
            tintImage($(this).attr('id'), $(this).attr('data-icon'), $(this).attr('data-color'));
        });

        // Este caso de completitud se lanzara tras comprobar la url con un endpoint para saber si se puede poner o no como iframe el recurso.
        // IZE-9629: Learning Path (SPECIAL) queda excluido — no debe generar su propio ciclo de
        // tracking genérico (start/update/stop); solo se marca en progreso localmente (ver abajo).
        if (document.type !== "URL" && document.type !== "PATH" && !document.isPathTestContent && !document.isPathGameContent && !document.isPathWizardPreviewContent) {
            that.documentationProgress.startRead(document.id);
        }

        if (document.type === 'PATH') {
            that.documentationProgress.setInProgress(document.id);
        }

        that.manageDocumentDetailsToggleButton(document, documentDetailsToggleButtonIcon);
        that.manageDocumentDetailsRate(document, openOption);
        that.manageDocumentationDetailsComments(document, isComment, openOption);
        that.manageDocumentationDetailsShare(folder, document, isSharing, openOption);
        that.manageDocumentViews(document);
        that.manageDocumentActiviy(document);
        that.carouselClick();

        this.getCompletedDocumentUsers(document.id, function(response) {
            DocumentationUtils.formatDocumentCompletedUsers(document, response);

            const completenessTitle = Translator.trans("TR_LO_HAN_COMPLETADO");
            const container = $(".document-completed-users");
            const context = {
                world: world,
                document: document,
                completenessTitle: completenessTitle
            }

            container.html(that.userCompletenessIndicatorTemplate(context));
        });

        $("#document-details-content .nav-link").on("click.selectedTab", function(e) {
            const tabName = $(this).attr("aria-controls");
            const commentsTabSelected = $("#document-details-content div.comments-tab").hasClass("active");

            // Al pulsar sobre la pestaña comentarios si no esta abierto ya el input de comentar abrirlo
            if (tabName === "comments" && !$(".openCommentButton").hasClass("world_color_1_bg")) {
                that.sendDetailsComment(document);
                return false;
            }

            // Al pulsar sobre otra pestaña si estaba abierto el input de comentar cerrarlo
            if ($(".openCommentButton").hasClass("world_color_1_bg") && (tabName === "information" || tabName === "activity")) {
                $("#documentComment-" + documentId + "-details").trigger("click");
            }

        });
    }


    drawDocumentUsersSocialActivityScreen(event) {

        const that = this;
        const currentTarget = $(event.currentTarget);
        const documentId = currentTarget.data("document");
        const commentId = currentTarget.data("comment");
        const socialType = currentTarget.data("type");
        const socialTypes = new SocialActivitiesTypes().getTypes();
        let dataContext = {};

        function setDirectoryData(listResponse, callbackFunction) {

            const userWorldIds = _.uniq(_.map(listResponse.result.users, 'user_world_id')).join(';');

            api.getUsersDirectory(userWorldIds, function(directoryResponse) {
                _.forEach(listResponse.result.users, function(userItem) {
                    const directoryData = _.find(directoryResponse.result.users, function(user) {
                        return parseInt(userItem.user_world_id) === parseInt(user.user_world_id);
                    });
                    if (directoryData) {
                        userItem.icon = directoryData.user_icon;
                        userItem.level_icon = directoryData.level.icon;
                        userItem.level_color = directoryData.level.color;
                    }
                });
                callbackFunction(listResponse.result.users);
            });

        }

        if (socialType === socialTypes.LIKE_COMMENT_ACTIVITY_TYPE) {

            api.getDocumentCommentLikes(commentId, null, function(response) {

                if (api.checkisValidResult(response)) {

                    setDirectoryData(response, function(friends) {

                        dataContext = {
                            iconName: "icoLike",
                            title: Translator.trans("TR_ME_GUSTA"),
                            subtitle: response.result.total === 1 ? Translator.trans("TR_1_USUARIO") : sprintf(Translator.trans("TR_X_USUARIOS"), response.result.total),
                            listType: socialTypes.LIKE_COMMENT_ACTIVITY_TYPE,
                            documentId: documentId,
                            commentId: commentId,
                            friends: friends,
                        }

                        worldHomeController.friends = friends;
                        dataListFriendsController.initialize(dataContext);

                        $(".data-list-section .section-content").off().on("click.openFriendProfile", ".friend-item.is-directory", function(event) {
                            event.preventDefault();
                            event.stopPropagation();
                            api.getUserProfile(world.token, $(this).data("user"), false);
                        });

                        that.slideActionsFriendList.initialize();

                    });

                }

            });

        } else {

            api.getDocumentUsersSocialActivity(documentId, socialType, null, function(response) {

                if (api.checkisValidResult(response)) {

                    setDirectoryData(response, function(friends) {

                        switch (socialType) {

                            case socialTypes.SEEN_ACTIVITY_TYPE:
                                dataContext = {
                                    iconName: "icoView",
                                    title: Translator.trans("TR_VISUALIZACIONES"),
                                    subtitle: response.result.total === 1 ? Translator.trans("TR_1_USUARIO") : sprintf(Translator.trans("TR_X_USUARIOS"), response.result.total),
                                    listType: socialTypes.SEEN_ACTIVITY_TYPE,
                                    documentId: documentId,
                                    commentId: commentId,
                                    friends: friends,
                                }
                                break;

                            case socialTypes.FAVOURITE_ACTIVITY_TYPE:
                                dataContext = {
                                    iconName: "icoFavourite",
                                    title: Translator.trans("TR_FAVORITOS"),
                                    subtitle: response.result.total === 1 ? Translator.trans("TR_1_USUARIO") : sprintf(Translator.trans("TR_X_USUARIOS"), response.result.total),
                                    listType: socialTypes.FAVOURITE_ACTIVITY_TYPE,
                                    documentId: documentId,
                                    commentId: commentId,
                                    friends: friends,
                                }
                                break;

                            case socialTypes.COMPLETED_ACTIVITY_TYPE:
                                dataContext = {
                                    iconName: "icoContentCompletedBlack",
                                    title: Translator.trans("TR_COMPLETADOS"),
                                    subtitle: response.result.total === 1 ? Translator.trans("TR_1_USUARIO") : sprintf(Translator.trans("TR_X_USUARIOS"), response.result.total),
                                    listType: socialTypes.COMPLETED_ACTIVITY_TYPE,
                                    documentId: documentId,
                                    commentId: commentId,
                                    friends: friends,
                                }
                                break;

                            case socialTypes.LIKE_DOCUMENT_ACTIVITY_TYPE:
                                dataContext = {
                                    iconName: "icoLike",
                                    title: Translator.trans("TR_ME_GUSTA"),
                                    subtitle: response.result.total === 1 ? Translator.trans("TR_1_USUARIO") : sprintf(Translator.trans("TR_X_USUARIOS"), response.result.total),
                                    listType: socialTypes.LIKE_DOCUMENT_ACTIVITY_TYPE,
                                    documentId: documentId,
                                    commentId: commentId,
                                    friends: friends,
                                }
                                break;

                        }

                        worldHomeController.friends = friends;
                        dataListFriendsController.initialize(dataContext);

                        $(".data-list-section .section-content").off().on("click.openFriendProfile", ".friend-item.is-directory", function(event) {
                            event.preventDefault();
                            event.stopPropagation();
                            api.getUserProfile(world.token, $(this).data("user"), false);
                        });

                        that.slideActionsFriendList.initialize();

                    });

                }

            });
        }

    }

    carouselClick() {
        let that = this;

        $('.carousel-element').off().on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if(that.isDragging) {
                return;
            }

            let subtype = $(this).data('sub-type');
            let docId = $(this).data('resource');
            let tabId = $(this).data('world-tab');  // La pestaña que hay que abrir en caso de enlace a un mundo
            let folder = that.getParentFolder(docId, documentationScreenController.documentation, false, true);
            let currentDocument = folder != null ? folder['documents'][that.getDocumentIndex(docId, false, folder)] : null;

            that.shortCuts(subtype, docId, null, tabId);
        });
    }

    manageDocumentContainers(folder){
        let that = this;
        that.getScreen();

        let videoContainer = $(that.screen).find(".document-preview-advanced-container[data-folder='" + folder.id +"'] .advanced-view-video-container");
        let audioContainer = $(that.screen).find(".document-preview-advanced-container[data-folder='" + folder.id +"'] .advanced-view-audio-container");
        let buttonContainer = $(that.screen).find(".document-preview-advanced-container[data-folder='" + folder.id +"'] .advanced-button-doc-access-container");

        function resizeElements(container){
            container.height(container.width()*9/16);
        }

        if (that.folderModeView === "advanced") {
            resizeElements(audioContainer);
            resizeElements(buttonContainer);
        }

        $(window).off("resize.docContainers").on("resize.docContainers", function(){
            if (that.folderModeView === "advanced") {
                resizeElements(audioContainer);
                resizeElements(buttonContainer);
            }
        });

        $(".document-preview-advanced-container[data-folder='" + folder.id +"'] .advanced-view-video-container, " +
            ".document-preview-advanced-container[data-folder='" + folder.id +"'] .advanced-view-audio-container").off().on("contextmenu", function(e){
            return false;
        });
    }

    triggerExternalLinkEvent(type, documentId){
        ga('send', 'event', analytics.GA_CATEGORY_DOCUMENTATION, analytics.GA_CATEGORY_DOCUMENTATION_EVENT_ACCESS_DOCUMENT, documentId);

        const that = this;
        let currentDocument = this.getDocument(documentId);

        swal({
                title: "",
                text: Translator.trans("TR_CONTENIDO_ABIERTO"),
                closeOnConfirm: true,
                allowEscapeKey : false
            });
    }

    showBottomArea(actionGroup, actionButton, buttonBorder, iconUrl, currentDocument=null){
        let bottomSection = $(".bottomDisplayedSection");
        let oldVisibleGroup = bottomSection.find('div:visible');
        bottomSection.find('div').hide();

        let that = this;

        if(!oldVisibleGroup.length || actionGroup.is(oldVisibleGroup)){
            bottomSection.toggle();
        }

        if(actionGroup.is("#shareInputGroup") ) {
            let linkController = new SharedLinkScreenController();
            linkController.draw(currentDocument);
        } else {
            $(actionGroup).find('div').show();
        }

        actionGroup.show(1, function () {
            if(bottomSection.is(':visible')){
                $(".document-details-info").css('padding-bottom', bottomSection.outerHeight() + 'px');
            } else {
                $(".document-details-info").css('padding-bottom', "");
            }
        });

        if(!actionButton.hasClass('copyClipboardButton'))
            actionButton.toggleClass('world_color_1_bg');

        let canvas = actionButton.find('canvas');

        if(!actionButton.hasClass('copyClipboardButton'))
            canvas.toggleClass("bottom-icon-black detailsSelectedColor");
        tintImage(canvas.attr('id'), customIcons[iconUrl], rgb2hex(canvas.css('color')));
    }

    sendDetailsComment(document){
        let that = this;

        $(".openCommentButton").toggleClass("world_color_1_bg");

        if ($(".openCommentButton").hasClass("world_color_1_bg")) {
            this.documentationComment.openWritingSection();
        } else {
            this.documentationComment.hideWritingSection();
        }

        this.documentationComment.enableMentions($("textarea.comment-textarea"), ".mentions-list-container", ".mentions-list-container > .mentions-results", ".friend-item.is-directory");

        let sendCommentIcon = $('#sendCommentIcon-' + document.id + '-details');
        sendCommentIcon.off();

        sendCommentIcon.one('click', function(){

            let commentArea = $('.comment-textarea');
            let commentValue = "";
            const replyToCommentId = $(".reply-to-comment-container > .comment-content").data("reply");
            commentArea.mentionsInput('val', function(text) {
                commentValue = text;
            });

            if(commentValue.length > 0){
                $("#addCommentInputGroup").hide();
                $(".sendingMessageText").show();
                that.elapsedSendingTime = new Date();

                ga('send', 'event', analytics.GA_CATEGORY_DOCUMENTATION, analytics.GA_CATEGORY_DOCUMENTATION_EVENT_MAKE_COMMENT, document.id);
                that.documentationComment.addComment(document.id, commentValue, replyToCommentId);
            }
        });
    }

    // Puede ser que un folder y un doc tengan el mismo id
    getParentFolder(documentId, currentFolder, findInFolder  = true, findInDocs  = true){
        // Buscar documentos y foldes
        if(findInDocs && currentFolder) {
            for (let index in currentFolder.documents) {
                if (currentFolder.documents[index].id == documentId)
                    return currentFolder;
            }
        }

        if(findInFolder && currentFolder) {
            for (let index in currentFolder.folders) {
                if (currentFolder.folders[index].id == documentId)
                    return currentFolder;
            }
        }

        let folderSelected = null;
        if(currentFolder) {
            for (let index in currentFolder.folders) {
                folderSelected = this.getParentFolder(documentId, currentFolder.folders[index], findInFolder, findInDocs);
                if (folderSelected) {
                    return folderSelected;
                }
            }
        }

        return null;
    }

    search(term) {

        function applySearch(){

            let color = null;

            if(currentFolder.color.indexOf("#") >= 0){
                color = currentFolder.color;
            } else {
                color = '#' + currentFolder.color;
            }

            let resultFolder = {
                id: new Date().getTime(),
                name: Translator.trans('TR_RESULTS'),
                color: color,
                documents: resultDocuments,
                isResult: true
            };

            if(activeFilters.length > 0){

                activeFilters = that.toggleCurrentFilter(activeFilters);

                that.drawFolder(resultFolder, false, false, true, function() {
                    DocumentationUtils.drawFilters(activeFilters,  resultFolder);
                });
            } else {
                that.drawFolder(resultFolder);
            }

            $(screen).find('.documentation-searchbar').val(term);
        }

        let currentFolder = this.getCurrentFolder();
        let resultDocuments = [];
        let startFolderId = currentFolder.id;
        let activeFilters = $('.filterEnabled');
        let lastReadingItem = this.documentationScroll.currentReadingDocument;
        let that = this;
        let screen = that.screen;
        const filters = {
            is_completed_by_user: $(".documents-filter[data-filter=completed]").last().data("status") === 1,
            is_fav_to_user: $(".documents-filter[data-filter=favourite]").last().data("status") === 1,
            is_new_to_user: $(".documents-filter[data-filter=new]").last().data("status") === 1,
            has_test: $(".documents-filter[data-filter=test]").last().data("status") === 1,
            has_question: $(".documents-filter[data-filter=play]").last().data("status") === 1,
            order_by_rating: $(".documents-filter[data-filter=rating]").last().data("status") === 1,
            is_shared_by_user: $(".documents-filter[data-filter=share]").last().data("status") === 1,
        }

        _.forEachRight(documentationScreenController.foldersStack, function(folder) {
            if (!folder.isResult) {
                startFolderId = folder.id;
                return false;
            }
        });

        api.searchDocumentsInFolder(startFolderId, term, filters, function(response) {

            resultDocuments = response.result ? Object.values(response.result) : [];

            if (activeFilters.length > 0) {
                that.updateScreensStack();
                currentFolder = that.getCurrentFolder();
            }

            if (currentFolder.name === Translator.trans('TR_RESULTS')) {
                that.updateScreensStack();
                currentFolder = that.getCurrentFolder();
            }

            if (term.length || activeFilters.length > 0) {
                if (lastReadingItem && lastReadingItem.length > 0) {
                    this.documentationSockets.callbackReadingFunc = function () {
                        applySearch();
                    };

                    this.documentationScroll.stopCurrentReadingItem(null, $('.documentation-advanced-documents-row[data-folder="' + currentFolder.id + '"]').first());
                } else {
                    applySearch();
                }
            } else if (storage.getItem("documentation-advanced-mode") === 'true') {
                if (currentFolder.documents && currentFolder.documents.length > 0) {
                    let firstListItem = $(screen).find(".documentation-advanced-documents-row[data-folder='" + currentFolder.id + "']").first();
                    that.documentationScroll.markAsReadingItem(firstListItem);
                }
                $(screen).find('.documentation-searchbar').val('');
            }
        });
    }

    /**
     * @param {Object} folder
     * @param {string} term
     * @returns {Array}
     */
    searchInFolder(folder, term) {

        let resultDocuments = [];
        let documents = this.getFolderDocumentsFilter(folder);
        let regex = new RegExp(term, 'i');

        documents.forEach(function (doc) {
            let tagFound = false;

            if(doc.tags) {
                let docTags = doc.tags.split(",");
                docTags.forEach(function (tag) {
                    if (regex.test(tag.trim())) {
                        tagFound = true;
                    }
                });
            }

            if (tagFound || regex.test(doc.name)) {
                doc.color = folder.color;
                // Evitar repetidos
                if(resultDocuments.indexOf(doc) === -1) {
                    resultDocuments.push(doc);
                }
            }
        });

        resultDocuments = resultDocuments.map(function(el) {
            var o = $.extend({}, el);
            if(!o.parentFolder)
                o.parentFolder = {'name': folder.name, 'color': folder.color, 'colorCode': folder.color.replace('#', '')};
            return o;
        });

        return resultDocuments;
    }

    toggleCurrentFilter(activeFilters, currentFilter){
        let updatedFilters = [];
        let filterType = null;
        let filterStatus = null;

        if(typeof(currentFilter) !== 'undefined'){
            filterType = currentFilter.attr('data-filter');
            filterStatus = currentFilter.attr('data-status');
        }

        activeFilters.each(function (){
            if((filterType !== null && $(this).attr('data-filter') !== filterType) || !filterType){
                updatedFilters.push({'filterType': $(this).attr('data-filter'), 'status': $(this).attr("data-status")});
            }
        });

        if(filterType !== null) {
            if (updatedFilters.length === activeFilters.length) {
                updatedFilters.push({'filterType': filterType, 'status': "1"});
            }
        }

        return updatedFilters;
    }

    adjustImageCarousel(carouselList){
        let height = this.getCarouselHeight($(carouselList).data('height'));
        let numImg = this.calcCarouselImgSize(carouselList, height);
        let that = this;

        if (!height) {  // Si no es un carrousel que redimensione la imagen (galeria)
            $(window).resize(() => {
                carouselList.height(carouselList.width());
                numImg = this.calcCarouselImgSize(carouselList, height);
            });
        }

        carouselList.each(function() {

            const document = that.getDocument($(this).data("document"));
            let dotsContString = '';
            let images = $(this).find('img').length > 0 ? $(this).find('img') : $(this).find('.image');

            if($(this).data('document') && $(this).data('folder')){
                dotsContString = '#custom-dots-carousel-advanced-' +
                    $(this).data('document') + '-' + $(this).data('folder');
            } else {
                dotsContString = '#custom-dots-carousel-details';
            }

            $(this).owlCarousel({
                checkVisible: false,
                startPosition: finderController.documentMatch ? finderController.documentMatch : 0,
                items: numImg,
                lazyLoad: true,
                lazyLoadEager: images.length - numImg,
                center: document.type === "DECO_GALLERY" ? false : true,
                autoWidth: true,
                dotsContainer: dotsContString,
                nav: true,
                navText: ['<div class="carousel-paginator-icon"><i class="fa fa-angle-left"></i></div>',
                    '<div class="carousel-paginator-icon"><i class="fa fa-angle-right"></i></div>']
            });

            let dotsContainer = $(dotsContString);
            let activeDot = dotsContainer.find(".owl-dot.active");
            let lastActiveDot = dotsContainer.find('.owl-dot').first();
            lastActiveDot.nextAll('*:gt(3)').addClass('hidden-dot');

            let firstDot = dotsContainer.find('.owl-dot').not('.hidden-dot').first();
            let lastDot = dotsContainer.find('.owl-dot').not('.hidden-dot').last();

            lastActiveDot.data('last-active', true);
            activeDot.find('span').css({'width': '8px', 'height': '8px'});
            dotsContainer.find(".owl-dot").css({'top': '-3.5px'});
            dotsContainer.find(".owl-dot").find('span').css({'width': '8px', 'height': '8px'});
            $(dotsContString + '.owl-dots' +  ' .owl-dot span').css('background', '#FFFFFF');
            $(dotsContString + '.owl-dots' +  ' .owl-dot.active span').css('background', '#' + world.theme.color_2);

            let btnWidth = lastActiveDot.width();
            //show 5 buttons
            dotsContainer.width(btnWidth*5);
            let totalPages = dotsContainer.find('.owl-dot').length;

            if(totalPages > 5) {
                lastDot.css({top: '-5px'});
                lastDot.find('span').css({'width': '4px', 'height': '4px'});
            }

            let counterTimeout = null;
            let prevPage = $(this).find('.owl-nav .owl-prev');
            let nextPage = $(this).find('.owl-nav .owl-next');
            $(this).find('.owl-nav').css('margin', 0);

            if (totalPages === 1 || activeDot.index() + 1 === 1) {
                prevPage.hide();
            }
            
            if (!checkSelectorEvents($(this), ['drag.owl.carousel', 'changed.owl.carousel']).eventsIncluded) {

                $(this).off('drag.owl.carousel').on('drag.owl.carousel', function (e) {
                    e.stopPropagation();

                    that.isDragging = true;
                });

                $(this).off('dragged.owl.carousel').on('dragged.owl.carousel', function (e) {
                    e.stopPropagation();

                    setTimeout(() => {
                        that.isDragging = false;
                    }, 60);
                });



                $(this).off('changed.owl.carousel').on('changed.owl.carousel', function(e) {
                    e.stopPropagation();

                    dotsContainer = $(dotsContString);
                    let activeDot = dotsContainer.find(".owl-dot.active");
                    let currentPage = activeDot.index() + 1;
                    let documentId = that.currentDocumentDetails ? that.currentDocumentDetails.id : that.documentationScroll.currentReadingDocument;

                    if(totalPages === 1) {  // Una slide
                        nextPage.hide();
                        prevPage.hide();
                    } else if (currentPage === 1) { // Primera slide
                        nextPage.show();
                        prevPage.hide();
                    } else if (currentPage === totalPages) { // Ultima slide
                        prevPage.show();
                        nextPage.hide();
                    } else {
                        if (prevPage.is(':hidden'))
                            prevPage.show();

                        if (nextPage.is(':hidden'))
                            nextPage.show();
                    }

                    if (counterTimeout)
                        clearTimeout(counterTimeout);

                    let counter = null;

                    if ($(this).closest(".document-preview-advanced-container").length) {
                        counter = $(this).closest(".document-preview-advanced-container").find(".owl-carousel-counter");
                    } else {
                        counter = $(this).closest(".previewThumbnail").find(".owl-carousel-counter");
                    }

                    counter.find(".counter-current-page").text(currentPage);

                    if (!counterTimeout) {
                        counter.fadeIn();
                    }

                    counterTimeout = setTimeout(function () {
                        counter.fadeOut('fast');
                        counterTimeout = null;
                    }, 1600);

                    dotsContainer.find(".owl-dot").not(activeDot).css({'top': '-3.5px'});
                    dotsContainer.find(".owl-dot").not(activeDot).find('span').css({'width': '8px', 'height': '8px'});
                    $(dotsContString + '.owl-dots' +  ' .owl-dot span').css('background', '#FFFFFF');
                    $(dotsContString + '.owl-dots' +  ' .owl-dot.active span').css('background', '#' + world.theme.color_2);

                    if (!activeDot.next().data('last-active') && activeDot.nextAll().not(".hidden-dot").length <= 1 && activeDot.nextAll().is('.hidden-dot')) {
                        lastDot.next().removeClass('hidden-dot');
                        dotsContainer.find(".owl-dot").animate({
                            left: parseInt(activeDot.css('left')) - btnWidth + 'px'
                        }, 'fast');
                        firstDot.addClass('hidden-dot');
                    } else if (activeDot.next().data('last-active') && activeDot.prevAll().not(".hidden-dot").length <= 1 && activeDot.prevAll().is('.hidden-dot')) {
                        firstDot.prev().removeClass('hidden-dot');
                        dotsContainer.find(".owl-dot").animate({
                            left: parseInt(activeDot.css('left')) + btnWidth + 'px'
                        }, 'fast');

                        lastDot.addClass('hidden-dot');
                    }

                    firstDot = dotsContainer.find('.owl-dot').not('.hidden-dot').first();
                    lastDot = dotsContainer.find('.owl-dot').not('.hidden-dot').last();

                    if (firstDot.prev().length && firstDot.prev().is('.hidden-dot')){
                        firstDot.css({top: '-5px'});
                        firstDot.find('span').css({'width': '4px', 'height': '4px'});
                    }

                    if (lastDot.next().length && lastDot.next().is('.hidden-dot')) {
                        lastDot.css({top: '-5px'});
                        lastDot.find('span').css({'width': '4px', 'height': '4px'});
                    }

                    lastActiveDot.removeData('last-active');
                    lastActiveDot = activeDot;
                    activeDot.data('last-active', true);

                    setTimeout(() => {
                        that.isDragging = false;
                    }, 100);
                });
            }
        });
    }

    calcCarouselImgSize(carouselList, height = null){
        let numImg = 0;
        let widthImg = 0;

        carouselList.each(function() {
            let images = $(this).find('img').length > 0 ? $(this).find('img') : $(this).find('.image');
            let carousel = $(this);

            images.each(function () {
                let imgWidth = parseFloat($(this).data('width'));
                let imgHeight = parseFloat($(this).data('height'));
                let screenWidth = carousel.width();
                let screenHeight = carousel.width();
                let ratio = screenHeight / imgHeight;

                if(imgWidth*ratio > screenWidth)
                    ratio = screenWidth / imgWidth;

                if (height) {
                    ratio = height / imgHeight;
                }

                let reescaledWidth = imgWidth * ratio;
                let reescaledHeight = imgHeight * ratio;

                widthImg += reescaledWidth;
                if(widthImg  < screenWidth) {
                    numImg += 1;
                }

                $(this).width(reescaledWidth);
                $(this).height(reescaledHeight);
                $(this).css('max-height', reescaledHeight);
                $(this).css('background-repeat', 'no-repeat');
                $(this).css('background-size', 'contain');
            });
        });
        // En el caso en el que numImg sea 0 es porque la imagen es mas grande que la ventana, en este caso como maximo habra un elemento por slide del carousel.
        // La imagen quedara ajustada al ancho del contenedor de la App
        return numImg > 0 ? numImg : 1;
    }

    getCarouselHeight(size) {
        switch (size) {
            case "LARGE":
                return 500;
            case "MEDIUM":
                return 300;
            case "SMALL":
                return 100;
        }
    }

    filtersEnabled(){
        let gameMode = !world.documentation_game_mode || (!world.show_play_filter && !world.show_question_filter );
        let showQuestionFilter = !world.shows_completion || !world.show_question_filter;
        let showRateFilter = !world.can_rate_documentation || !world.show_order_filter;

        // Comprobar si no hay habilitado ningun filtro
        let showSearch = gameMode && showQuestionFilter && !world.show_favourite_filter && !world.show_new_filter && showRateFilter && !world.show_link_filter;
        world.showSearch = showSearch;

        return showSearch;
    }

    sortDocumentElements(documentsList) {
        _.forEach(documentsList, function(document) {
            if (document.type === 'DECO_GALLERY') {
                document.images.sort(function(document1, document2){
                    return document1.order - document2.order
                });
            }
        });
    }

    changeFolderModeView() {

        const advancedView = storage.getItem("documentation-advanced-mode") === 'true';
        const screen = this.getScreen();
        const currentFolder = this.getCurrentFolder();;
        const documentId = this.documentationScroll.currentReadingDocument ? this.documentationScroll.currentReadingDocument : null;
        const document = this.getDocument(documentId);
        let activeFilters = $(screen).find('.filterEnabled');

        if (document) {
            this.documentationProgress.stopRead(document.id);
        }

        this.updateScreensStack();
        storage.setItem("documentation-advanced-mode", !advancedView);
        this.folderModeView = advancedView ? 'standar' : 'advanced';

        if (activeFilters.length > 0) {
            const noFiltersFolder = this.getCurrentFolder();
            activeFilters = this.toggleCurrentFilter(activeFilters);
            this.drawFolder(noFiltersFolder, false, false);
        }

        this.drawFolder(currentFolder, false, false, true, function () {
            if(activeFilters.length > 0) {
                DocumentationUtils.drawFilters(activeFilters, currentFolder);
            }
        });

    }

    updateScreensStack() {

        $('.stackable').last().remove();
        $('.stackable').last().show();
        this.foldersStack.pop();
        this.getScreen();

    }

    manageDocumentDetailsRate(document, openOption) {

        if(world.can_rate_documentation) {

            let that = this;

            $('#documentRate-' + document.id + '-details').click(function (e) {

                if ($("#shareInputGroup").is(":visible")) {
                    $(".copyClipboardButton").trigger("click");
                }

                if ($(".write-section-comment").hasClass("is-open")) {
                    $("#documentComment-" + document.id + "-details").trigger("click");
                }

                that.showBottomArea($("#rateInputGroup"), $(".openRatingButton"), $('#rating-selected-border-' + document.id), 'DOCUMENTATION_BOTTOM_NAVIGATION_RATE');

                let rateImages = $('#rateInputGroup span');
                rateImages.off();
                rateImages.one('click', function(){
                    let points = $(this).attr('data-rating');

                    $("#rateInputGroup").hide();
                    $(".ratingMessageText").show();

                    that.elapsedSendingTime = new Date();

                    ga('send', 'event', analytics.GA_CATEGORY_DOCUMENTATION, analytics.GA_CATEGORY_DOCUMENTATION_EVENT_RATE_DOCUMENT, document.id);
                    docSocket.emit(SocketEvents.RATE_DOCUMENT_REQUEST(), JSON.stringify({rating: points, document_id: document.id}));
                });
            });

            if (openOption === that.RATE_OPTION) {
                $('#documentRate-' + document.id + '-details').trigger("click");
            }

        }

    }

    manageDocumentationDetailsComments(document, isComment, openOption) {

        function getDocumentComments() {

            api.getDocumentComments(document.id, requestFrom, commentsLimit, function(commentsResponse) {
                if (api.checkisValidResult(commentsResponse)) {

                    // Lista de world ids de los usuarios que han escrito los comentarios para saber si les sigo o no
                    const userWorldIds = _.uniq(_.map(commentsResponse.result.comments, 'user_world_id')).join(';');

                    api.getUsersDirectory(userWorldIds, function(directoryResponse) {
                        if (api.checkisValidResult(directoryResponse)) {

                            _.forEach(commentsResponse.result.comments, function(comment) {
                                comment.author_data = _.find(directoryResponse.result.users, function(user) {
                                    return parseInt(comment.user_world_id) === parseInt(user.user_world_id);
                                })
                            });

                            that.documentationComment.initialize(commentsResponse.result.comments);
                            $(".comments-tab").on("scroll.getMoreComments", onScrollBottom);
                        }
                    });
                }
            });

        }

        function getMoreDocumentComments() {

            api.getDocumentComments(document.id, requestFrom, commentsLimit, function(commentsResponse) {
                if (api.checkisValidResult(commentsResponse)) {

                    // Lista de world ids de los usuarios que han escrito los comentarios para saber si les sigo o no
                    const userWorldIds = _.uniq(_.map(commentsResponse.result.comments, 'user_world_id')).join(';');

                    api.getUsersDirectory(userWorldIds, function(directoryResponse) {
                        if (api.checkisValidResult(directoryResponse)) {

                            pendingRequest = false;

                            _.forEach(commentsResponse.result.comments, function(comment) {
                                comment.author_data = _.find(directoryResponse.result.users, function(user) {
                                    return parseInt(comment.user_world_id) === parseInt(user.user_world_id);
                                })
                            });

                            that.documentationComment.drawMoreComments(commentsResponse.result.comments);
                        }
                    });
                }
            });

        }

        function onScrollBottom() {

            const scrollHeight = $(".comments-tab")[0].scrollHeight;
            const activityTabHeight = $(".comments-tab").height();
            const currentScrollPosition = $(".comments-tab").scrollTop();
            const distanceToBottom = 100;

            if (currentScrollPosition > lastScrollPosition && currentScrollPosition + activityTabHeight >= scrollHeight - distanceToBottom) {

                if (!pendingRequest) {

                    pendingRequest = true;
                    requestFrom = $(".document-comment").length;
                    getMoreDocumentComments();

                }

            }

            lastScrollPosition = currentScrollPosition;

        }

        let that = this;
        let lastScrollPosition = 0;
        let pendingRequest = false;
        let requestFrom = 0;
        let commentsLimit = 10;

        if(world.can_comment_documentation) {

            if(isComment){
                that.sendDetailsComment(document);
            }

            $('#documentComment-' + document.id + '-details, #not-info-button-' + document.id).click(function (e) {
                e.preventDefault();
                that.sendDetailsComment(document);
            });

            // Opcion a abrir directamente si se ha clickado en ella desde la vista avanzada
            if (openOption === this.COMMENT_OPTION) {
                that.sendDetailsComment(document);
            }

            getDocumentComments();

        }

    }

    manageDocumentationDetailsShare(folder, document, isSharing, openOption) {

        if(world.can_share_documents && document.enabledLinks) {

            let that = this;

            $('.copyClipboardButton').click(function () {

                if ($("#rateInputGroup").is(":visible")) {
                    $('#documentRate-' + document.id + '-details').trigger("click");
                }

                if ($(".write-section-comment").hasClass("is-open")) {
                    $("#documentComment-" + document.id + "-details").trigger("click");
                }

                $(this).css('pointer-events', 'none');
                that.showBottomArea($("#shareInputGroup"), $(".copyClipboardButton"), $('.shareSelectedBorder'), 'DOCUMENTATION_BOTTOM_NAVIGATION_SHARE', document);
                $(".copyClipboardButton").css('pointer-events', 'auto');

                if(!document.is_shared){
                    let advancedShareButton = $("#documentShare-" + document.id + "-advanced-" + folder.id);
                    $(this).toggleClass('world_color_1_bg');
                    if(advancedShareButton.length){
                        advancedShareButton.closest(".bottomOptionSelected").toggleClass('world_color_1_bg');
                    }
                }
            });

            if(isSharing){
                if(!document.is_shared){
                    $(".share-document").addClass('world_color_1_bg');

                    // Mostrar de rojo el icono "shared" de detalles
                    let currentFolder = that.getCurrentFolder();
                    let activeFilters = $('.filterEnabled');
                    let searchTerm = $('.documentation-searchbar').val();
                    let advancedShareButton = $("#documentShare-" + document.id + "-advanced-" + currentFolder.id);

                    if (activeFilters.length > 0 || searchTerm.length > 0 || document.sub_type === 'DOCUMENT') {
                        currentFolder = that.getParentFolder(document.id, that.documentation);
                    }
                    if (advancedShareButton.length) {
                        advancedShareButton.closest(".bottomOptionSelected").toggleClass('world_color_1_bg');
                    }
                }
            }

            // Opcion a abrir directamente si se ha clickado en ella desde la vista avanzada
            if (openOption === this.SHARE_OPTION) {
                $('.copyClipboardButton').trigger('click');
            }

        }

    }

    manageDocumentDetailsToggleButton(document, documentDetailsToggleButtonIcon) {

        const that = this;
        const totalHeight = $(window).height();
        const optionsButtonsBar = $(".bottomOptionsButtons").last();
        const docOptionsBarHeight = $(".bottomOptionsBar").last().height();
        const keepTheLoopShowButton = $(".show-keep-the-loop-button");

        if (document.type === "PATH" || $("div.path-wizard-preview-item").length) {
            optionsButtonsBar.hide();
        }

        DocumentationUtils.calcDetailsViewHeight();

        $("#document-details-toggle-button, #document-details-content .close-button").off().click(function(e) {
            e.preventDefault();
            if(documentDetailsToggleButtonIcon.hasClass("opened")) {

                // Si se cierra la ficha con la seccion de comentarios abierta cerrarla
                if ($("div.write-section-comment").hasClass("is-open")) {
                    $("#documentComment-" + document.id + "-details").trigger("click");
                }

                $("#document-details-content").animate({"height": "0px"}, function() {
                    $(this).removeClass("opened");
                    documentDetailsToggleButtonIcon.removeClass("opened");

                    if (document.type === "PATH" || $(".path-wizard-preview-item").length) {
                        optionsButtonsBar.hide();
                    }

                    if (keepTheLoopShowButton.length > 0) {
                        keepTheLoopShowButton.show();
                    }

                });
            } else {
                $("#document-details-content").animate({"height": totalHeight - docOptionsBarHeight + "px"}, function() {
                    $(this).addClass("opened");
                    documentDetailsToggleButtonIcon.addClass("opened");

                    if (document.type === "PATH" || $(".path-wizard-preview-item").length) {
                        optionsButtonsBar.show();
                    }

                    if (keepTheLoopShowButton.length > 0) {
                        keepTheLoopShowButton.hide();
                    }

                });
            }

        });
    }

    manageDocumentViews(document) {

        const that = this;
        let documentDetailsViewSelector = $('#documentationDetailSection .document-visualizations-value');
        let documentAdvancedViewSelector =  $('.documentation-advanced-documents-row[data-document=' + document.id + '] .document-visualizations-value');

        // Al acceder a la vista detalles se incrementa el contador de vistas
        if (this.folderModeView === 'details' && !that.documentsViews[document.id]) {
            api.increaseDocumentViews(document.id).done(function(response) {
                if (api.checkisValidResult(response)) {
                    documentDetailsViewSelector.text(response.result.visualizations);
                    if (documentAdvancedViewSelector.length > 0) {
                        documentAdvancedViewSelector.text(response.result.visualizations);
                    }
                    document.visualizations = response.result.visualizations;
                }
            });
            that.documentsViews[document.id] = true;
        // Al consumir un documento desde la vista avanzada...
        } else if (this.folderModeView === 'advanced' && !that.documentsViews[document.id]) {
            // ...si es de tipo imagen o galeria se incrementa el contador de vistas
            if (document.type === 'IMAGE' || document.type === 'GALLERY') {
                api.increaseDocumentViews(document.id).done(function(response) {
                    if (api.checkisValidResult(response)) {
                        documentAdvancedViewSelector.text(response.result.visualizations);
                        document.visualizations = response.result.visualizations;
                    }
                });
            }
            // ...si es de tipo video o audio se incrementa el contador de vistas cuando se empieze a reproducir
            if (document.type === 'VIDEO' || document.type === 'AUDIO') {
                $('.documentation-advanced-documents-row[data-document=' + document.id + ']').find(document.type).one('timeupdate', function() {
                    api.increaseDocumentViews(document.id).done(function(response) {
                        if (api.checkisValidResult(response)) {
                            documentAdvancedViewSelector.text(response.result.visualizations);
                            document.visualizations = response.result.visualizations;
                        }
                    });
                })
            }
            that.documentsViews[document.id] = true;
        }

    }

    manageDocumentActiviy(document) {

        function getDocumentSocialActivity() {

            api.getDocumentSocialActivity(document.id, null, requestFrom, function(response) {

                if (api.checkisValidResult(response)) {

                    paginationKey = response.result.pagination_key;
                    requestFrom = response.result.social_activity.length

                    _.forEach(response.result.social_activity, function(socialActivity) {
                        if (socialActivity.comment_text) {
                            socialActivity.comment_text = DocumentationUtils.formatCommentMentions(socialActivity.comment_text, socialActivity.mentions, null);
                        } else if (socialActivity.comment_removed) {
                            socialActivity.comment_text = Translator.trans("TR_ELIMINADO");
                        }
                    });

                    $("#document-details-content .activity-tab").html(that.documentActivityTab({
                        socialActivity: response.result.social_activity,
                        showEmptyActivityMessage: true
                    }));
                    $(".activity-tab").on("scroll.getMoreActivities", onScrollBottom);
                    $("div.activity-tab").on("click.activityUserProfile", "span.open-profile-button", function(event) {

                        event.preventDefault();
                        event.stopPropagation();

                        const userWorldId = $(event.currentTarget).data("user");
                        api.getUserProfile(world.token, userWorldId, false);

                    });

                }

            });

        }

        function getMoreDocumentSocialActivity() {

            api.getDocumentSocialActivity(document.id, paginationKey, requestFrom, function (response) {

                pendingRequest = false;
                requestFrom += response.result.social_activity.length

                _.forEach(response.result.social_activity, function(socialActivity) {
                    if (socialActivity.comment_text) {
                        socialActivity.comment_text = DocumentationUtils.formatCommentMentions(socialActivity.comment_text, socialActivity.mentions, null);
                    } else if (socialActivity.comment_removed) {
                        socialActivity.comment_text = Translator.trans("TR_ELIMINADO");
                    }
                });

                $("#document-details-content .activity-tab").append(that.documentActivityTab({
                    socialActivity: response.result.social_activity,
                    showEmptyActivityMessage: false
                }));

            });

        }

        function onScrollBottom(paginationKey) {

            const scrollHeight = $(".activity-tab")[0].scrollHeight;
            const activityTabHeight = $(".activity-tab").height();
            const currentScrollPosition = $(".activity-tab").scrollTop();
            const distanceToBottom = 100;

            if (currentScrollPosition > lastScrollPosition && currentScrollPosition + activityTabHeight >= scrollHeight - distanceToBottom) {

                if (!pendingRequest) {

                    pendingRequest = true;
                    getMoreDocumentSocialActivity();

                }

            }

            lastScrollPosition = currentScrollPosition;

        }

        const that = this;
        let lastScrollPosition = 0;
        let pendingRequest = false;
        let paginationKey = null;
        let requestFrom = 0;

        getDocumentSocialActivity();

    }

    startDocumentTypeGameOrTest(gameDocument, testDocument, pathDocument) {

        let folder = this.getCurrentFolder();
        const documentOpenedInChat = chatScreenController.projectDocumentDetailsOpen;
        const that = this;

        if (documentOpenedInChat) {

            const documentId = $('.open-project-document-details').data('document');
            folder = this.getParentFolder(documentId, this.documentation);

        }

        // Se guarda en documentObj el documento y la ruta de carpetas donde se encuentra para poder volver a la ubicacion al terminar el juego.
        // En path el tipo de media a mostrar en el countdown debe ser una imagen y debe ser la de portada del path.
        if (pathDocument) {

            if (gameDocument) {
                documentObj = new DocumentObj(gameDocument, this.foldersStack, pathDocument.id);
            }

            if (testDocument) {
                documentObj = new DocumentObj(testDocument, this.foldersStack, pathDocument.id);
            }

        } else if (gameDocument) {
            documentObj = new DocumentObj(gameDocument, this.foldersStack);
        } else if (testDocument) {
            documentObj = new DocumentObj(testDocument, this.foldersStack);
        }

        if (gameDocument) {

            const stackMenuContext = {
                title: '',
                icon: 'close',
                fullScreenHeader: true,
                withoutHeader: true,
            }
            const stackContentContext = {
                world: world,
                countdownType: gameDocument.own_game.media_type,
                countdownURL: gameDocument.url,
                withoutHeader: true
            }
            const countdown360Options = {
                radius: 40,
                seconds: 3,
                fontFamily: "Roboto",
                strokeWidth: 6,
                label: [],
                fillStyle: 'transparent',
                strokeStyle: '#FFFFFF',
                fontSize: 20,
                fontColor: '#FFFFFF',
                autostart: false,
                onComplete: function() {
                    $("#countdown-counter").hide();
                    $(".countdown-finish-text").removeClass("d-none");
                    if (finderController.documentOpen) {
                        finderController.documentOpen = false;
                    }
                    api.createNewDocumentGame(gameDocument.id);
                }
            }

            baseController.stackSimpleMenu(stackMenuContext, this.singleMenuTemplate);

            const isModuleApp = window.reactZustandBridge && world && world?.mode === 'newLayout';

            if (isModuleApp) {
                baseController.stackGameInModuleApp(this.countdownTemplate, stackContentContext);
            } else {
                baseController.stackSimpleContent(this.countdownTemplate, stackContentContext, 'GAME');
            }

            $("#countdown-counter").show();
            $(".countdown-finish-text").addClass("d-none");

            this.countDownGame = $("#countdown-counter").countdown360(countdown360Options);

            if (!gameDocument.own_game.media_type || gameDocument.own_game.media_type === 'IMAGE') {
                this.countDownGame.start();
            }

            if (gameDocument.own_game.media_type === 'VIDEO') {

                $('.countdown-video-background video').on('ended', function (e) {
                    $('.countdown-counter-background').removeClass('d-none');
                    that.countDownGame.start();
                });

            }

        } else if (testDocument) {

            if (finderController.documentOpen) {
                finderController.documentOpen = false;
            }

            api.createNewDocumentGame(testDocument.id);

        }

    }

    getCompletedDocumentUsers(documentId, callbackFunction) {

        const visibleModalLoading = $('#modalLoading').is(":visible");

        function _getCompletedDocumentUsers() {

            api.getCompletedDocumentUsers(documentId, function(response) {
                if (api.checkisValidResult(response)) {
                    callbackFunction(response);
                }
            }, false);

        }

        // Si todavia esta la modal de carga es porque existen peticiones sin acaban, para evitar que aparezca la modal de carga en esta peticion esperar a que se oculte la modal.
        setTimeout(_getCompletedDocumentUsers, visibleModalLoading ? 200 : 0);

    }

    // Mostrar la ficha de la vista detalles (Pintar pantalla y ocultar lo innecesario)
    openDocumentDetailsFile(document, folder, option) {
        const lastFolderModeView = this.folderModeView;
        const that = this;

        this.drawDocumentDetails(null, document, option, folder, true);

        if ($(".my-contents-section").length > 0) {
            $(".my-contents-section").show();
        } else {
            $(".documentationSectionStackable").last().show();
        }

        $("#documentationDetailSection > .wrapper").hide();
        $("#documentation-header-close-btn").hide();

        //Special drawer (from wall)
        if(
            (option === this.COMMENT_OPTION || option === this.SEE_ALL_COMMENTS_OPTION) ||
            (option === this.SHARE_OPTION) ||
            (option === this.RATE_OPTION)
        ) {
            setTimeout(function () {
                let openDrawerBtn = $('.wrapper-desktop .open-content-drawer');

                if(openDrawerBtn.length === 0) {
                    openDrawerBtn = $('button[data-name=open-content-drawer]');
                }

                if (openDrawerBtn) {
                    openDrawerBtn.trigger("click");

                    if (option === this.SHARE_OPTION) {
                        setTimeout(function () {
                            $(".drawer-documentation-details-content #information-tab").trigger('click');

                            setTimeout(function () {
                                $(".drawer-documentation-details-content .share-document").trigger('click');
                            }, 1900);
                        }, 800);
                    }
                }
            }, 1000);

        }

        //special drawer
        if (option === this.COMMENT_OPTION || option === this.SEE_ALL_COMMENTS_OPTION) {
            setTimeout(function() {
                $("#comments-tab").trigger("click");
            }, 450);
        }

        $("#document-details-toggle-button").trigger("click");

        $("#document-details-toggle-button, #document-details-content .close-button")
            .on("click.closeDetails", function() {
            if (option === that.SHARE_OPTION && !document.is_shared) {
                $(".bf-smart-list[data-document=" + document.id + "] .share-button-advanced").parent().removeClass("world_color_1_bg");
            }

            setTimeout(function() {
                baseController.closeSimpleMenu();
                that.folderModeView = lastFolderModeView;

                if (that.folderModeView !== 'details') {
                    that.currentDocumentDetails = null;
                }

            }, 400);

        });

        window.scrollTo(0, documentationScreenController.scrollPosition);
    }

    openDocumentPathDetailsFile(document, folder, option) {
        const card = window.document.querySelector(
            `.documentation-documents-row .bf-smart-list.list[data-document= "${document.id}"]`
        );

        if(!card) {
            return;
        }

        card.click();

        if(option === this.COMMENT_OPTION || option === this.SEE_ALL_COMMENTS_OPTION) {
            setTimeout(function () {
                const openCommentsDrawer = window.document.querySelector(
                    `button[data-name="open-comments-drawer"]`
                );

                if(openCommentsDrawer) {
                    openCommentsDrawer.click();
                }
            }, 1200);
        }

        // if(option === this.SHARE_OPTION && !document.is_shared) {
        if(option === this.SHARE_OPTION) {

            setTimeout(function () {
                const openContentDrawer = window.document.querySelector(
                    `button[data-name="open-content-drawer"]`
                );

                if(openContentDrawer) {
                    openContentDrawer.click();

                    setTimeout(() => {
                        $(".drawer-documentation-details-content #information-tab").trigger('click');

                        $(".drawer-documentation-details-content #documentShare-" + document.id + "-details").trigger('click');

                    }, 500);
                }
            }, 1200);
        }

        window.scrollTo(0, documentationScreenController.scrollPosition);
    }

    setExtraDocumentsInfo(docs, folder) {
        const that = this;

        _.forEach(docs, function(doc) {
            doc.progressState = that.documentationProgress.getProgressState(doc);
            doc.location = that.documentsRoutes[doc.id];
            doc.external = doc.external && !DocumentationUtils.isSpecialDocument(doc.type);

            if (DocumentationUtils.isSpecialDocument(doc.type)) {
                let docTypeSpecialView = null;

                if (doc.type === 'GAME') {
                    docTypeSpecialView = doc.own_game.special_view;
                }
                if (doc.type === 'TEST') {
                    docTypeSpecialView = doc.own_test.special_view;
                }
                if (doc.type === 'POLL') {
                    docTypeSpecialView = doc.own_poll.special_view;
                }
                if (doc.type === 'TASK') {
                    docTypeSpecialView = false; //test value
                }

                if (documentationScreenController.folderModeView === 'advanced') {
                    doc.special_view = !doc.is_compact_view && (folder.default_game_special_view || docTypeSpecialView);
                } else if (documentationScreenController.folderModeView === 'standar') {
                    doc.special_view = folder.default_game_special_view || docTypeSpecialView;
                }

            }

            if (doc.type === 'GAME' && doc.own_game.games.length > 0) {
                doc.own_game.total_points = _.sumBy(doc.own_game.games, "total_points");
                doc.own_game.last_game = _.maxBy(doc.own_game.games, function(game) { return game.end_date });
                doc.own_game.is_button_visible = doc.own_game.num_tries - doc.own_game.games.length > 0 || !doc.own_game.num_tries;
            }

            if (doc.type === 'TEST' && doc.own_test.games.length > 0) {
                doc.own_test.best_game = _.maxBy(doc.own_test.games, function(game) { return game.qualification });
                doc.own_test.last_game = _.maxBy(doc.own_test.games, function(game) { return game.end_date });
            }

            if (doc.type === "PATH") {
                api.getPath(doc.path_id, function(response) {
                    that.documentationPath.setSmartListPathProgress(doc, response.result.path);
                    that.documentationPath.setSmartListPathIndicators(doc, response.result.path);
                    that.documentationPath.setSmartListPathTime(doc, response.result.path);
                }, false);
            }

            if (doc.last_comment) {
                doc.last_comment.comment = DocumentationUtils.formatCommentMentions(doc.last_comment.comment, doc.last_comment.mentions, doc.last_comment.user_world_id);
            }

        });
    }

    setDocumentsMargins(docs) {

        const that = this;

        // Sobre la vista especial de los documentos se debe añadir un padding inferior solo si el siguiente documento no tiene la vista especial
        // Ademas si el ultimo elemento es vista especial y no existe la posibilidad de subir documentos tambbien se le debe dejar padding inferior
        _.forEach(docs, function(doc, index) {

            const row = $(that.screen).find('[row-data-index=' + index + ']');

            if (row.hasClass('documentation-documents-special-row') && index < docs.length - 1) {

                const nextRow = $(that.screen).find('[row-data-index=' + (index + 1) + ']');

                if (!nextRow.hasClass('documentation-documents-special-row')) {
                    row.addClass('next-document-default-view');
                }
            } else if (row.hasClass('documentation-documents-special-row') && index === docs.length -1 && !world.can_upload_documents) {
                row.addClass('upload-documents-disabled');
            }

        });
    }

    setCarouselConfig(folder, global = true) {
        const that = this;
        const carrousel = global ?
            $(that.screen).find(".owl-carousel-advanced[data-folder='" + folder.id + "']") :
            $(".owl-carousel-advanced[data-folder='" + folder.id + "']");

        _.forEach(carrousel, function (imgCarousel) {
            that.adjustImageCarousel($(imgCarousel));
        });

        that.carouselClick();
    }

    setFolderNameEllipsis(folder) {

        const that = this;

        if(folder.folders){
            $(that.screen).find(".documentation-folder-name").dotdotdot({
                wrap: 'word',
                watch: true,
            });
        }

    }

    setTaskViewEvents() {
        const that = this;

        $(document)
            .off('click.drawDocumentTask')
            .on('click.drawDocumentTask', '.task-card-view', function() {
                const documentId = $(this).attr('data-document');
                const parentFolder = that.getParentFolder(documentId, that.documentation);
                const doc = that.getDocument(documentId, parentFolder);

                that.drawDocumentDetails(null, doc, null, parentFolder);
            });
    }

    setStandarViewEvents() {
        const that = this;

        $(document)
            .off('click.drawDocumentDetails')
            .on('click.drawDocumentDetails', '.bf-smart-list.smart-view', function() {

            if (!smartListsController.getDraggingCarousel()) {
                const documentId = $(this).attr('data-document');
                const parentFolder = that.getParentFolder(documentId, that.documentation);
                const doc = that.getDocument(documentId, parentFolder);

                if (doc.type === 'GAME') {
                    that.drawDocumentDetails(null, doc, null, parentFolder);
                    return false;
                }

                if (doc.type === 'POLL') {
                    if (doc.own_poll.games.length === 0) {
                        documentObj = new DocumentObj(doc, that.foldersStack);
                        api.createNewDocumentGame(doc.id);
                        return false;

                    }
                }

                if (doc.type === "PATH") {
                    that.documentationPath.getPath(doc.path_id, function(pathData) {
                        doc.pathData = pathData;
                        that.drawDocumentDetails(null, doc, null, parentFolder);
                    });

                    return false;

                }

                that.drawDocumentDetails(null, doc, null, parentFolder);
            }

        });

        // FIX super feo para IE (como no)
        if(bowser.msie){
            var $documentationFoldersDataContent = $('.documentation-folders-data-content');
            if($documentationFoldersDataContent.height() < $documentationFoldersDataContent.width())  {
                $documentationFoldersDataContent.height($documentationFoldersDataContent.width());

                $(window).off('resize.touchIeEvent');

                $(window).on('resize.touchIeEvent', function () {
                    $documentationFoldersDataContent.height($documentationFoldersDataContent.width());
                });
            } else {
                $documentationFoldersDataContent.height($documentationFoldersDataContent.height());

                $(window).off('resize.touchIeEvent');

                $(window).on('resize.touchIeEvent', function () {
                    $documentationFoldersDataContent.height($documentationFoldersDataContent.height());
                });
            }
        }

    }

    setAdvancedDocumentsConfig() {

        const that = this;

        $(".bf-smart-list.wall .panel-description").each(function(){
            if ($(this).find(".description").height() > 60) {
                $(this).addClass("collapsed");
                $(this).find(".collapsible-icon").removeClass("d-none").addClass("collapsed");
            }
        });

        $(".pie-chart-container").each(function () {
            DocumentationUtils.drawTestPieChart($(this));
        });

        $(".background-icon").each(function () {
            let iconTitle = 'RATE_SMILE_' + $(this).data('rating');
            $(this).css('background-image', 'url(' + customIcons[iconTitle] + ')');
        });

        $(".image-doc-rating").each(function () {
            let iconTitle = 'RATE_SMILE_' + $(this).data('rating');
            $(this).attr('src', customIcons[iconTitle])
        });

        $(".tintedCanvas").each(function () {
            tintImage($(this).attr('id'), $(this).attr('data-icon'), $(this).attr('data-color'));
        });

    }

    setAdvancedViewEvents(folder) {

        const that = this;

        if (!world.documentation_autoplay) {
            $(document).off('click.playMedia').on('click.playMedia', '.advanced-view-video-container, .advanced-view-audio-container', function() {

                const documentationPastil = $(this).find('.documentation-pastil');
                const documentationMedia = $(this).find($(this).attr('data-type'));

                if (documentationPastil.length > 0) {

                    documentationPastil.remove();
                    documentationMedia.attr('controls', true);
                    setTimeout(function(){documentationMedia[0].play()}, 100);

                }

            });
        }

        $(document).off("click.extendDocDescription").on("click.extendDocDescription", ".bf-smart-list.wall .panel-description", function() {
            $(this).toggleClass("collapsed");
            $(this).find(".collapsible-icon").toggleClass("collapsed");
        });

        $(document).off('click.chatShareDocumentAdvanced').on('click.chatShareDocumentAdvanced', '.chat-share-document-advanced', function() {
            that.documentationShareChat.initChatShareSection(folder.id, $(this).data('document'));
        });

        $(document).off('click.advancedToDetails').on('click.advancedToDetails', '.folder-wall-item-controller .doc-details-access-button', that.advancedToDetails);

        $(".mark-liked-advanced").off("click.markAsILiked").on("click.markAsILiked", function(e) {

            e.preventDefault();

            const documentId = $(this).data("document");
            const gifDocumentLiked = $("#gif-document-liked-" + documentId + "-advanced-" + folder.id);

            // Prevenir error al pulsar varias veces seguidas y rapido sobre el boton de like.
            if (gifDocumentLiked.children().length === 0) {
                docSocket.emit(SocketEvents.SET_LIKE_REQUEST(), JSON.stringify({document_id: documentId}));
            }

        });

        $(".mark-comment-liked-advanced").off("click.markCommentAsILiked").on("click.markCommentAsILiked", function(e) {

            e.preventDefault();

            const commentId = $(this).data("comment");
            const gifCommentLiked = $("#gif-comment-liked-" + commentId + "-advanced-" + folder.id);

            // Prevenir error al pulsar varias veces seguidas y rapido sobre el boton de like.
            if (gifCommentLiked.children().length === 0) {
                docSocket.emit(SocketEvents.SET_LIKE_COMMENT_REQUEST(), JSON.stringify({comment_id: commentId}));
            }

        });

        $(".see-all-comments-button, .comment-button-advanced")
            .off("click.openDocumentFile")
            .on("click.openDocumentFile", function(e) {

            e.preventDefault();

            const documentId = $(this).data("document");
            const document = that.getDocument(documentId);
            const openCommentOption = $(this).data("comment");

            that.openDocumentDetailsFile(document, folder, openCommentOption ? that.COMMENT_OPTION : that.SEE_ALL_COMMENTS_OPTION);
        });

        $('.advanced-rate-input-bar span').off('click.rateInputBar').on('click.rateInputBar', function(){
            let points = $(this).attr('data-rating');
            let rateBar = $(this).closest('.advanced-rate-input-bar');
            let documentId = rateBar.data('document');

            rateBar.siblings('.document-advanced-rating-background').hide();
            rateBar.hide();

            that.elapsedSendingTime = null;

            ga('send', 'event', analytics.GA_CATEGORY_DOCUMENTATION, analytics.GA_CATEGORY_DOCUMENTATION_EVENT_RATE_DOCUMENT, documentId);
            docSocket.emit(SocketEvents.RATE_DOCUMENT_REQUEST(), JSON.stringify({rating: points, document_id: documentId}));
        });

        $(".social-activity-button-advanced").off("click.showDataList").on("click.showDataList", this.drawDocumentUsersSocialActivityScreen.bind(this));

        $(".share-button-advanced").off("click.openDocumentFile").on("click.openDocumentFile", function(e) {

            e.preventDefault();

            const documentId = $(this).data("document");
            const document = that.getDocument(documentId);

            that.openDocumentDetailsFile(document, folder, that.SHARE_OPTION);

        });

        $(".mark-favourite-advanced-" + folder.id).off("click.markFavouriteAdvanced").on("click.markFavouriteAdvanced", function (e) {
            e.preventDefault();
            ga('send', 'event', analytics.GA_CATEGORY_DOCUMENTATION, analytics.GA_CATEGORY_DOCUMENTATION_EVENT_MAKE_FAVOURITE, $(this).data("document"));
            docSocket.emit(SocketEvents.SET_FAVORITE_REQUEST(), JSON.stringify({document_id: $(this).data("document")}));
        });

        $('.openRatingButtonAdvanced').off("click.openRatingbuttonAdvanced").on("click.openRatingbuttonAdvanced", function(){
            let docId = $(this).data('document');
            let rateBar = $(that.screen).find('#rate-input-' + docId);
            let rateArea = rateBar.siblings('.document-advanced-rating-background');
            rateArea.toggle();
            rateBar.toggle();
            $(this).toggleClass('world_color_1_bg');
        });

    }

}
